<template>
  <div id="app">
    <div @touchmove.prevent v-if="sheetzt" style="position:fixed;width:100%;left:0;top:0;height:100%;background:rgba(0,0,0,0.5);z-index:1000;">
      <div style="font-size: .48rem;background: rgb(255, 255, 255);width: 60%;height: 20%;position: absolute;left: 20%;top: 35%;display: flex;justify-content: space-around;align-items: center;">
        {{zfpicknr}}
      </div>
    </div>
    <div id="loader-wrapper">
        <div id="loader"></div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
        <div class="load_title">{{picktan[pickxb].jiazai}}……</div>
    </div>
	<div class="depot">
		<div class="depotdiv" :style="'width:'+(2.2*(MadeDepotlist.length+1))+'rem;'">
			<div :class="(MadeDepotlistxb)==0?'on':''" @click="Depotclick(0)">
				{{pickn[pickxb].qb}}
			</div>
			<div v-for="(item,index) in MadeDepotlist" :class="(index+1)==MadeDepotlistxb?'on':''" @click="Depotclick(index+1)">
				<template v-if="WXLangGoodsxb==0">{{item.MadeDepot}}</template>
				<template v-if="WXLangGoodsxb==1">{{item.TwoMadeDepot}}</template>
				<template v-if="WXLangGoodsxb==2">{{item.ThreeMadeDepot}}</template>
			</div>
		</div>
	</div>
    <div class="navMenuType" v-show="!cur" ref="scrollOne" style="position:fixed;top:2rem;">
      <swiper class="ul" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item,index) in feilist"  :class="index==fei_xb?'on':''" :key="index" v-if="MadeDepotlist[MadeDepotlistxb>0?MadeDepotlistxb-1:0].MadeDepotID==item.MadeDepotID||MadeDepotlistxb==0">
          <a @click="feiclick(index,false)" v-if="WXLangGoodsxb==0 && index!=feilist.length-1" style="">{{item.TypeName}}</a>
          <a @click="feiclick(index,false)" v-if="WXLangGoodsxb==1 && index!=feilist.length-1" style="">{{item.TwoTypeName}}</a>
          <a @click="feiclick(index,false)" v-if="WXLangGoodsxb==2 && index!=feilist.length-1" style="">{{item.ThreeTypeName}}</a>
        </swiper-slide>
      </swiper>
    </div>
    <!--菜品列表-->
    <div class="goodsBigDiv" style="width:70%;top:2rem;z-index:-1;" v-show="!cur"ref="piediv">
      <!--v-if="feilist[fei_xb].TypeID==item.TypeID"-->
      <div v-for="(items,index) in pq" v-if="MadeDepotlist[MadeDepotlistxb>0?MadeDepotlistxb-1:0].MadeDepotID==items.MadeDepotID||MadeDepotlistxb==0">
        <div v-if="WXLangGoodsxb==0 && index!=pq.length-1" id="pqname" class="pqname">一一{{items.name1}}一一</div>
        <div v-if="WXLangGoodsxb==1 && index!=pq.length-1" id="pqname" class="pqname">一一{{items.name2}}一一</div>
        <div v-if="WXLangGoodsxb==2 && index!=pq.length-1" id="pqname" class="pqname">一一{{items.name3}}一一</div>
        <div class="goodsList" v-for="(item,index2) in items.sz" v-if="item.IsMenu && index!=pq.length-1">
          <div class="goodsRight" @click="xqclick(index,index2,item.IsUnitPrice,item.DisRemark)" >
            <img loading="lazy" style="width:2.2rem;height:2.2rem;" @error="imageLoad(index,index2)" :src="item.src" mode="aspectFill" ref="errimg"/>
            <!--<span class="span" v-if="item.IsEmpty">Sellout</span>-->
          </div>
          <div class="goodsLift">

            <div v-if="WXLangGoodsxb==0" @click="xqclick(index,index2,item.IsUnitPrice,item.DisRemark)" class="goodsName">{{item.Goods}}</div>
            <div v-if="WXLangGoodsxb==1" @click="xqclick(index,index2,item.IsUnitPrice,item.DisRemark)" class="goodsName">{{item.TwoGoods}}</div>
            <div v-if="WXLangGoodsxb==2" @click="xqclick(index,index2,item.IsUnitPrice,item.DisRemark)" class="goodsName">{{item.ThreeGoods}}</div>

            <div style="display:flex;height:.5rem;width:2.5rem;">
              <img v-if="item.IngredientsICO1" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P1.png'"/>
              <img v-if="item.IngredientsICO2" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P2.png'"/>
              <img v-if="item.IngredientsICO3" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P3.png'"/>
              <img v-if="item.IngredientsICO4" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P4.png'"/>
              <img v-if="item.IngredientsICO5" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P5.png'"/>
              <img v-if="item.IngredientsICO6" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P6.png'"/>
              <img v-if="item.IngredientsICO7" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P7.png'"/>
              <img v-if="item.IngredientsICO8" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P8.png'"/>
              <img v-if="item.IngredientsICO9" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P9.png'"/>
              <img v-if="item.IngredientsICO10" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P10.png'"/>
              <img v-if="item.IngredientsICO11" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P11.png'"/>
              <img v-if="item.IngredientsICO12" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P12.png'"/>
              <img v-if="item.IngredientsICO13" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P13.png'"/>
              <img v-if="item.IngredientsICO14" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P14.png'"/>
              <img v-if="item.IngredientsICO15" :src="$lujin+'/Data/'+ShopID+'/IngredientsICO/P15.png'"/>
            </div>

            <div v-if="WXLangGoodsxb==0&&item.Description!=''"  class="beizhu" style="margin-bottom:0">{{item.Description}}</div>
            <div v-if="WXLangGoodsxb==1&&item.TwoDescription!=''"  class="beizhu" style="margin-bottom:0">{{item.TwoDescription}}</div>
            <div v-if="WXLangGoodsxb==2&&item.ThreeDescription!=''"  class="beizhu" style="margin-bottom:0">{{item.ThreeDescription}}</div>

            <div class="goodsBottom"  @click="xqclick(index,index2,item.IsUnitPrice,item.DisRemark)" style="height:2.2rem;">
              <div class="goodsPrice" v-if="IsBuffet">
                {{MoneySymbol}}{{item.IsBuffetGoods?(item.Price>0?item.Price.toFixed(DecimalBit):item.Price):item.MessyPrice.toFixed(DecimalBit)}}
              </div>
			  <template v-if="!IsBuffet">
				  <template v-if="IsTaxIncluded">
					  <div class="goodsPrice" style="width:100%;text-align:left;font-size:0.32rem;">
					    {{MoneySymbol}}{{item.TaxBeforeMoney.toFixed(DecimalBit)}}
					  </div>
					  <div class="goodsPrice" style="color:#666;width:100%;text-align:left;font-size:0.28rem;">
					    {{MoneySymbol}}{{item.SaleTaxSubTotal.toFixed(DecimalBit)}}({{pickn[pickxb].hs}})
					  </div>
				  </template>
				  <template v-if="!IsTaxIncluded">
					  <div class="goodsPrice" style="width:100%;text-align:left;">
					    {{MoneySymbol}}{{item.MessyPrice.toFixed(DecimalBit)}}({{pickn[pickxb].bh}})
					  </div>
				  </template>
			  </template>
            </div>
            <div class="goodsAdd" v-if="!item.IsEmpty">
              <img v-if="item.sl>0" src="../../static/images/jian.png" @click="addGoods($event,item.IsUnitPrice,index,index2,false,item.DisRemark)"/>
              <span v-if="item.sl>0" >{{item.sl}}</span>
			  <div v-if="item.MinShare>0&&item.sl==0" style="color:#fff;font-weight:100;font-size:0.28rem;width:1.2rem;height:.5rem;line-height:.5rem;background:orange;border-radius:.25rem;" @click="addGoods($event,item.IsUnitPrice,index,index2,true,item.DisRemark)">
				+{{item.MinShare}}{{pickn[pickxb].dw}}
			  </div>
              <img v-else src="../../static/images/add.png" @click="addGoods($event,item.IsUnitPrice,index,index2,true,item.DisRemark)"/>
            </div>
          </div>

        </div>
      </div>

      <div class="cart">
      <div class="ball-wrapper" v-for="(ball, index) of balls" :key="index">
        <transition
          name="drop"
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
        >
          <div class="ball" v-show="ball.show">
            <!--这里为了做两个维度的动画，因此需要多包一层，外层做Y轴，内层做X轴动画-->
            <div class="inner inner-hook" :style="[{'background':bgcolor}]"></div>
          </div>
        </transition>
      </div>
    </div>
    </div>
    <!--底部-->
    <div class="tab" v-show="!cur">
      <div style="width:10%;"></div>
      <div @click="curclick">
        <img :class="[rotate?'go':'aa']"  src="../../static/images/cur.png" />
        <span>{{pickyan[pickxb].gwc}}</span>
      </div>
      <div @click="hjclick" v-if="tableid!='Food'&&IsNeedServer">
        <img src="../../static/images/hujiao.png" />
        <span>{{picktan[pickxb].sfhj}}</span>
      </div>
      <div @click="ddclick">
        <img src="../../static/images/index.png" />
        <span>{{pickyan[pickxb].sp}}</span>
      </div>
      <div @click="tiaoclick" v-if="tableid!='Food'">
        <img :class="[rotate?'go':'aa']"  src="../../static/images/xx.png" />
        <span>{{zfpick[pickxb].ctxx}}</span>
      </div>
      <div @click="tiaoclick2" v-if="tableid=='Food'">
        <img :class="[rotate?'go':'aa']"  src="../../static/images/xx.png" />
        <span>{{zfpick[pickxb].ctxx}}</span>
      </div>
      <div style="width:10%;"></div>
      <div v-if="gwcsl>0" @click="curclick" class="gwcq">{{gwcsl}}</div>
    </div>
    <div v-if="PhoneState" style="background:rgba(0,0,0,0.5);position:fixed;width:100%;height:100%;left:0;top:0;z-index:1000;">
      <div style="width:75%;height:3.2rem;background:#fff;left:50%;top:25%;transform:translate(-50%,-50%);position:absolute;border-radius:0.2rem;">
        <div style="width:100%;line-height:.8rem;font-size:.36rem;">{{pickyan[pickxb].phone}}</div>
        <input type="text" v-model="phonetext" style="width:80%;margin:0 auto;height:1rem;border-radius:.2rem;"/>
        <div style="width:80%;margin:.5rem auto;display:flex;font-size:.32rem;justify-content:space-between;">
          <div @click="phoneclick">{{picktan[pickxb].qd}}</div>
          <div @click="PhoneState=false">{{picktan[pickxb].qx}}</div>
        </div>
      </div>
    </div>
    <!--语言选择-->

    <div id="yuyan" @touchmove.prevent  class="yuyan" v-show="!cur">
      <div style="height: 1rem;" @click="yydj">
        <img src="../../static/images/cd.png" style="width:.8rem;height:.8rem;margin:.1rem;"/>
      </div>
      <div class="search" style="width:4rem;">
        <input type="text" @keyup.enter="sstext" v-model="stext" :placeholder="pickn[pickxb].qsr" name="" id="" value="" />
        <img @click="sstext" src="../../static/images/ss.png" />
      </div>
        <vue-pickers
          :data="pickData"
          @confirm="confirm"
          :showToolbar="true"
          :maskClick="true"
          :visible.sync="pickerVisible"
          :cancelText="'No'"
          :confirmText="'Yes'"
          :layer="3"
          :link="true"
          ></vue-pickers>
		<div style="width:1.5rem;height:0.8rem;font-size:.28rem;color:red;text-align:center;">
			<template v-if="IsBuffetzt">{{DeskMin>0?DeskMin:0}}{{pickyan[pickxb].min}}</template>
		</div>
        <img src="../../static/images/lang.png" style="width:.8rem;height:0.8rem;margin:.1rem 0 .1rem 0rem;" @click="pickerVisible=true"/>

    </div>
    <!--商品详情-->
    <div class="xiangqing" v-if="pand" style="z-index:999;">
      <div class="xq_top">
        <img class="img" @click="xqesc" src="../../static/images/esc.png"/>
        <p @click="xqesc">{{pickxq[pickxb].fh}}</p>
        <span>{{pickxq[pickxb].spxq}}</span>
      </div>
      <div class="xq_img">
        <img @error="imageLoad2" ref="xqimg" :src="$lujin+'/Data/'+ShopID+'/GoodsPic/'+pq[xqxb_i].sz[xqxb_j].GoodsID+'.jpg?Time='+new Date().getTime()"/>
      </div>
      <div class="">
        <span style="font-size:.24rem;display: block;line-height: 0.4rem;width: 80%;margin: 0 auto;color:#999;" v-if="WXLangGoodsxb==0">{{pq[xqxb_i].sz[xqxb_j].Description}}</span>
        <span style="font-size:.24rem;display: block;line-height: 0.4rem;width: 80%;margin: 0 auto;color:#999;" v-if="WXLangGoodsxb==1">{{pq[xqxb_i].sz[xqxb_j].TwoDescription}}</span>
        <span style="font-size:.24rem;display: block;line-height: 0.4rem;width: 80%;margin: 0 auto;color:#999;" v-if="WXLangGoodsxb==2">{{pq[xqxb_i].sz[xqxb_j].ThreeDescription}}</span>
      </div>
      <div class="xq_main">
        <span v-if="WXLangGoodsxb==0" >{{pq[xqxb_i].sz[xqxb_j].Goods}}</span>
        <span v-if="WXLangGoodsxb==1" >{{pq[xqxb_i].sz[xqxb_j].TwoGoods}}</span>
        <span v-if="WXLangGoodsxb==2" >{{pq[xqxb_i].sz[xqxb_j].ThreeGoods}}</span>

        <p v-if="IsBuffet">{{MoneySymbol}}{{pq[xqxb_i].sz[xqxb_j].IsBuffetGoods?pq[xqxb_i].sz[xqxb_j].Price.toFixed(DecimalBit):pq[xqxb_i].sz[xqxb_j].MessyPrice.toFixed(DecimalBit)}}</p>
        <p v-if="!IsBuffet">{{MoneySymbol}}{{pq[xqxb_i].sz[xqxb_j].MessyPrice.toFixed(DecimalBit)}}</p>

      </div>

      <div class="xq_but">
        <span>{{pickxq[pickxb].sl}}</span>
        <div>
          <p  v-if="gmsl>0" @click="jianclick()">-</p>
          <span v-if="gmsl>0">{{gmsl}}</span>
          <p @click="jiaclick()">+</p>
        </div>
      </div>
      <div class="xq_gui" v-if="pq[xqxb_i].sz[xqxb_j].DisRemark"><!--12313-->
        <template v-if="IsNewGoodsRemark">
          <div v-for="(bpq,xb) in xq_la2">
            <div class="xq_qxz">
              <span v-if="WXLangGoodsxb==0">{{bpq.GroupName}}</span>
              <span v-if="WXLangGoodsxb==1">{{bpq.TwoGroupName}}</span>
              <span v-if="WXLangGoodsxb==2">{{bpq.ThreeGroupName}}</span>
            </div>
            <div class="xq_big">
              <div v-for="(item,index) in bpq.TRemarkGroupItemsTemp" @click="laclick2(xb,index)" :style="item.ZT?'border:2px solid red':'border:2px solid #000'">
                <span v-if="WXLangGoodsxb==0">
                  <span>{{item.Remark}}</span>
                  <span v-if="item.AddPrice>0">+</span>
                  <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice.toFixed(DecimalBit)}}</span>
                </span>
                <span v-if="WXLangGoodsxb==1">
                  <span>{{item.TwoRemark}}</span>
                  <span v-if="item.AddPrice>0">+</span>
                  <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice.toFixed(DecimalBit)}}</span>
                </span>
                <span v-if="WXLangGoodsxb==2">
                  <span>{{item.ThreeRemark}}</span>
                  <span v-if="item.AddPrice>0">+</span>
                  <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice.toFixed(DecimalBit)}}</span>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-if="!IsNewGoodsRemark">
          <div class="xq_qxz">
            <span>{{pickxq[pickxb].qxzzf}}</span>
          </div>
          <div class="xq_big">
            <div v-for="(item,index) in xq_la" @click="laclick(index)" :style="item.ZT?'border:2px solid red':'border:2px solid #000'">
              <span v-if="WXLangGoodsxb==0">
                <span>{{item.Remark}}</span>
                <span v-if="item.AddPrice>0">+</span>
                <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice}}</span>
              </span>
              <span v-if="WXLangGoodsxb==1">
                <span>{{item.TwoWorkReMark}}</span>
                <span v-if="item.AddPrice>0">+</span>
                <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice}}</span>
              </span>
              <span v-if="WXLangGoodsxb==2">
                <span>{{item.ThreeWorkReMark}}</span>
                <span v-if="item.AddPrice>0">+</span>
                <span style="color:red;" v-if="item.AddPrice>0">{{MoneySymbol}}{{item.AddPrice}}</span>
              </span>
            </div>
          </div>
        </template>
      </div>
      <div class="xq_gui" v-if="pq[xqxb_i].sz[xqxb_j].IsUnitPrice&&!IsBuffet">
        <div class="xq_qxz" v-if="xq_list>0">
          <span>{{pickxq[pickxb].qxzgg}}</span>
          <p>{{pickxq[pickxb].yx}}：{{xq_list?xq_list[ggxb].Unit:''}}&nbsp;{{xq_list?xq_list[ggxb].MessyPrice.toFixed(DecimalBit):0}}</p>
        </div>
        <div class="xq_list" @click="ggclick(index)" v-for="(i,index) in xq_list">
          <div>
            <span>{{i?i.Unit:''}}</span>
            <p style="color:red;" v-if="IsBuffet">
            {{pq[xqxb_i].sz[xqxb_j].IsBuffetGoods?pq[xqxb_i].sz[xqxb_j].Price.toFixed(DecimalBit):i.MessyPrice}}
            </p>
            <p style="color:red;" v-if="!IsBuffet">
            {{MoneySymbol}}{{i.MessyPrice.toFixed(DecimalBit)}}
            </p>
          </div>
          <img v-if="index==ggxb" src="../../static/images/xuanzhong.png"/>
        </div>
      </div>
      <div v-if="pq[xqxb_i].sz[xqxb_j].IsSetMeal">
        <div class="gd" v-if="pq[xqxb_i].sz[xqxb_j].IsFixup==1">
        	<div class="dwjgtop">{{foodlist[pickxb].on10}}</div>
        	<div class="kxlist">
        		<template v-for="(item,i) in gdlist">
        			<div class="guige2">
        				<div class="biaoti">
                  <template v-if="WXLangGoodsxb==0">{{item.Goods}}</template>
                  <template v-if="WXLangGoodsxb==1">{{item.TwoGoods}}</template>
                  <template v-if="WXLangGoodsxb==2">{{item.ThreeGoods}}</template>
        				</div>
        			</div>
        		</template>
        	</div>
        </div>
        <div class="bx" v-if="pq[xqxb_i].sz[xqxb_j].IsFixup==0" style="padding-bottom:3rem;">
          <div class="dwjgtop">{{foodlist[pickxb].on11}}</div>
          <div class="kxlist">
          	<template v-for="(item,i) in kexuanlist">
          		<div class="guige2"  @click="kxclick(i)" :key="item.SetMealGroupID">
          			<div class="biaoti">
                  <template v-if="WXLangGoodsxb==0">{{item.SetMealGroup}}</template>
                  <template v-if="WXLangGoodsxb==1">{{item.TwoSetMealGroup}}</template>
                  <template v-if="WXLangGoodsxb==2">{{item.ThreeSetMealGroup}}</template>
          				<template v-if="item.IsFixup!=1">
          					→<span v-if="item.IsFixup==0" style="color:red;">{{foodlist[pickxb].on9}}</span>({{item.sl}}/{{item.MaxSelItems}})
          				</template>
          			</div>
          			<div class="yxtext">
          				<span>
          					<template v-for="(items,j) in kexuanlist[i].list">
          						<span v-if="kexuanlist[i].list[j].zt">
          							<template v-if="WXLangGoodsxb==0">{{items.Goods}}</template>
          							<template v-if="WXLangGoodsxb==1">{{items.TwoGoods}}</template>
          							<template v-if="WXLangGoodsxb==2">{{items.ThreeGoods}}</template>
                        <span style="color:red;">{{items.Zuofa}}</span>
          							<span style="margin:0 .15rem;">|</span>
          						</span>
          					</template>
          				</span>
          			</div>
          		</div>
              <div class="list3">
              	<div class="bpq_button">
              		<div v-for="(items,j) in item.list" :key="items.ID">
              	    <div class="kxdpq">
              	      <span>
              	      	<span>
              	          <template v-if="WXLangGoodsxb==0">{{items.Goods}}</template>
              	          <template v-if="WXLangGoodsxb==1">{{items.TwoGoods}}</template>
              	          <template v-if="WXLangGoodsxb==2">{{items.ThreeGoods}}</template>
              	        </span>
              	      	<span style="color:#000;">{{items.Zuofa}}</span>
              	      	<span style="float: right;color:red;">
              	      		<template v-if="items.Price!=0">+{{MoneySymbol}}{{items.Price}}</template>
              	      	</span>
              	      </span>
              	    </div>
              	    <div class="wskxd" v-if="!items.IsEmpty&&item.IsFixup!='1'">
              	      <p @click="kxcpclick(j,0,i)">-</p>
              	      <input v-model="items.Qua" type="number" @input="bpqhans(i,j)"/>
              	      <p @click="kxcpclick(j,1,i)">+</p>
              	    </div>
                    <div v-else class="wskxd"><span>{{items.Qua}}</span></div>
              		</div>
              	</div>
              </div>
          	</template>
            <div style="width:100%;height:3rem;"></div>
          </div>
        </div>
      </div>
      <!--备注 <div class="cur_bz">
        <span>{{pickn[pickxb].bzxx}}</span>
        <textarea v-model="pq[xqxb_i].sz[xqxb_j].bz" :placeholder="pickn[pickxb].qsrbz"></textarea>
      </div>-->
      <div class="jrgwc"  @click="bzjr">{{pickxq[pickxb].jrgwc}}</div>
    </div>
    <!--购物车-->
    <div v-if="cur" class="cur" :style="gwclist.length>4?'position:relative':'position:absolute;'">
      <div class="xq_top">
        <img class="img" @click="escclick" src="../../static/images/esc.png"/>
        <p @click="escclick">{{pickxq[pickxb].fh}}</p>
        <span>{{pickyan[pickxb].gwc}}</span>
        <img v-if="gwclist.length!=0"  class="delete" @click="delclick" src="../../static/images/delete.png"/>
      </div>
      <div class="cheng"></div>
      <div class="cur_but" v-if="gwclist.length>0" >
        <div class="div">
          <div class="left">
            <img  @click="qxclick(quanxuan)" :src="quanxuan?'../../static/images/xuanzhong.png':'../../static/images/yuan.png'"/>
            <span @click="qxclick(quanxuan)">{{pickn[pickxb].qx}}</span>
          </div>
          <div class="rigth">
            <p>{{pickn[pickxb].hj}}</p>
            <h1>{{MoneySymbol}}{{zongji.toFixed(DecimalBit)}}</h1>
          </div>
        </div>
        <div class="xd" @click="xiadanpq">{{pickn[pickxb].xd}}</div>
      </div>
      <div v-if="gwclist.length==0" class="nullcur">
        <img src="../../static/images/bigcur.png"/>
        <span>{{zfpick[pickxb].kkry}}</span>
      </div>
      <div v-if="tableid=='Food'&&gwclist.length>0" class="food" >
        <div class="food_table" v-if="!($route.query.FoodState=='1'||$route.query.FoodState=='2')">
          <div :class="foodzt==0?'on':''" @click="foodzt=0">{{foodlist[pickxb].on1}}</div>
          <div :class="foodzt==1?'on':''" @click="foodzt=1">{{foodlist[pickxb].on2}}</div>
        </div>
        <div class="food_xxs">
          <div><span>※</span><input type="text" :placeholder="foodlist[pickxb].on3" v-model="foods.name" /></div>
          <div><span>※</span><input type="text" :placeholder="foodlist[pickxb].on4" v-model="foods.phone"/></div>
          <div v-if="foodzt==1"><span>★</span><input type="text" :placeholder="foodlist[pickxb].on5" v-model="foods.youb"/></div>
          <div v-if="foodzt==1"><span>※</span><input type="text" :placeholder="foodlist[pickxb].on6" v-model="foods.dizi"/></div>
          <div class="time" @click="datasj">
            <span v-if="foodzt==0">{{foodlist[pickxb].on7}}</span>
            <span v-if="foodzt==1">{{foodlist[pickxb].on8}}</span>
            <span class="foodspan">{{data_s}}:{{data_f}}</span>
          </div>
          <div v-if="PayState" class="time" @click="datasj2">
            <span>{{jpzf[pickxb].zf14}}</span>
            <span class="foodspan">{{PayFs.label}}</span>
          </div>
          <vue-pickers
            :data="wfz"
            @confirm="confirm2"
            :showToolbar="true"
            :visible.sync="sjzt"
            :defaultIndex="defaultlist"
            :cancelText="picktan[pickxb].qx"
            :confirmText="picktan[pickxb].qd"
            :rowNumber="7"
            :itemHeight="30"
            ></vue-pickers>
          <vue-pickers
            :data="wfz2"
            @confirm="confirm3"
            :showToolbar="true"
            :maskClick="true"
            :visible.sync="sjzt2"
            :cancelText="'No'"
            :confirmText="'Yes'"
            :layer="3"
            :link="true"
            ></vue-pickers>
        </div>
      </div>
      <div class="cur_list" v-for="(item,index) in gwclist" ref="xqdimg">
        <div class="cur_list_left">
          <img @click="djclick(index)" :src="item.zt?'../../static/images/xuanzhong.png':'../../static/images/yuan.png'"/>
          <img @error="imageLoad3(index)" :src="$lujin+'/Data/'+ShopID+'/GoodsPic/'+item.id+'.jpg'"/>
        </div>
        <div class="cur_list_rigth">
          <div v-if="WXLangGoodsxb==0" >{{item.Goods}}</div>
          <div v-if="WXLangGoodsxb==1" >{{item.TwoGoods}}</div>
          <div v-if="WXLangGoodsxb==2" >{{item.ThreeGoods}}</div>
          <!--备注-->
          <div @click="bzclick(index)">
            <img src="../../static/images/beiz.png"/>
            <p class="pbq">{{pickn[pickxb].bz}}：{{item.bz}}</p>
          </div>
          <div class="xq_but pos">
            <span v-if="item.cm">{{MoneySymbol}}{{item.cm.toFixed(DecimalBit)}}</span>
            <span v-else>{{MoneySymbol}}{{(item.momey).toFixed(DecimalBit)}}</span>
            <div>
              <p  v-if="item.IsChild==0" @click="gwcjian(index)">-</p>
              <span>{{item.sl}}</span>
              <p  v-if="item.IsChild==0" @click="gwcjia(index)">+</p>
            </div>
          </div>
        </div>
        <div v-if="WXLangGoodsxb==0" class="cur_beiz">{{item.zuofa1}}<template v-if="item.addmomey>0">+{{MoneySymbol}}{{item.addmomey}}</template></div>
        <div v-if="WXLangGoodsxb==1" class="cur_beiz">{{item.zuofa2}}<template v-if="item.addmomey>0">+{{MoneySymbol}}{{item.addmomey}}</template></div>
        <div v-if="WXLangGoodsxb==2" class="cur_beiz">{{item.zuofa3}}<template v-if="item.addmomey>0">+{{MoneySymbol}}{{item.addmomey}}</template></div>
      </div>
      <div class="cur_bz" v-if="gwclist.length>0" >
        <span>{{pickn[pickxb].bzxx}}</span>
        <textarea v-model="ggsq" :placeholder="pickn[pickxb].qsrbz"></textarea>
      </div>
      <div style="height:1rem;width: 100%;"></div>
    </div>
    <div v-if="jpzfzt" style="width:100%;height:100%;position:fixed;left:0;top:0;z-index:1001;background:#fff;overflow-y:scroll;">
      <div style="width:100%;">
        <div style="width:100%;text-align:center;font-size:.44rem;margin-top:1rem;">
          <template v-if="PayFs.id=='1'">{{jpzf[pickxb].zf1}}</template>
          <template v-if="PayFs.id=='2'">{{jpzf[pickxb].zf2}}</template>
          <template v-if="PayFs.id=='3'">{{jpzf[pickxb].zf3}}</template>
        </div>
        <div style="width:100%;text-align:center;font-size:.44rem;margin-top:.3rem;">
          <span style="color:red;">￥{{zongji}}</span>
          <span style="color:#000;" @click="fuzhi">{{jpzf[pickxb].zf4}}</span>
        </div>
        <div style="width:100%;">
          <img style="width:5rem;height:5rem;margin:.3rem auto;" :src="$lujin+'/Data/'+ShopID+'/Pay/Pay'+PayFs.id+'.png'"/>
        </div>
        <div style="width:96%;text-align:center;font-size:.36rem;margin:0 auto;">
          {{jpzf[pickxb].zf5}}
          <template v-if="PayFs.id=='1'">{{jpzf[pickxb].zf6}}</template>
          <template v-if="PayFs.id=='2'">{{jpzf[pickxb].zf7}}</template>
          <template v-if="PayFs.id=='3'">{{jpzf[pickxb].zf8}}</template>
          <span style="color:red;">{{jpzf[pickxb].zf9}}</span>{{jpzf[pickxb].zf11}}
          <br/>{{jpzf[pickxb].zf12}}
        </div>
        <div style="font-size:.5rem;width:4.5rem;height:1.2rem;border-radius:.3rem;border:1px solid blue;line-height:1.2rem;text-align:center;margin:1rem auto 0 auto;color:blue;" @click="xiadan">{{jpzf[pickxb].zf13}}</div>
        <div style="color:#999;font-size:.4rem;margin:.4rem auto;width:100%;padding-bottom:2rem;" @click="jpzfzt=false">{{picktan[pickxb].qx}}</div>
      </div>
    </div>
    <div class="toast" v-show="toastShow">{{toastText}}</div>
    <div class="confirmLayercovering" id="confirmLayercovering">
      <div class="confirmLayer" id="confirmLayer">
        <p class="confirmTit" id="confirmTit"></p>
        <textarea type="text" id="confirminput" style="resize: none;"></textarea>
        <div class="confirmbtns">
          <a class="confirmClose" id="confirmClose">{{picktan[pickxb].qx}}</a>
          <a class="confirmSure" id="confirmSure">{{picktan[pickxb].qd}}</a>
        </div>
      </div>
    </div>
    <div class="zdytc" v-if="canzt">
      <div class="mmmbbq">
         <p style="white-space: pre-wrap">{{cancen}}</p>
      </div>
      <div class="queding" @click="canzt=false">{{picktan[pickxb].qd}}</div>
    </div>
  </div>
</template>


<script>
  import '../../static/css/style.css'
  import '../../static/css/Default.css'
  import '../../static/css/swipeslider.css'
  import '../../static/js/rem.js'
  import throttle from '../../static/js/throttle.js'
  import 'swiper/swiper-bundle.css'
  import vuePickers from 'vue-pickers'
  import smoothscroll from 'smoothscroll-polyfill'
  import $ from 'jquery'
  import {swiper,swiperSlide} from "vue-awesome-swiper";
  export default {
    components: {
      swiper,
      swiperSlide,
      vuePickers
    },
    name: 'App',
    data() {
      return {
        wfz:[],
        Goodslist:[],
		MadeDepotlist:[{MadeDepotID:0}],
		MadeDepotlistxb:0,
        Menulist:[],
        wfz2:[
          {"label":"ABAPAY",id:"1"},
          {"label":"HuionePAY",id:"2"},
        ],
        sjzt:false,
        data_s:"00",
        data_f:"00",
        IsBuffetzt:false,
        jpzfzt:false,
        phonetext:"",
        PhoneState:false,
		IsNeedServer:false,
		IsTaxIncluded:false,
		IsMadeDepot:false,
		buffsz:[],
        stext:"",
        Shop:'',
        Address:'',
        PayFs:{
          "label":"",id:0
        },
        Qlist:[],
        gdlist:[],
        IsSetMealzt:false,
        IsSetMealxb:0,
        setlists:[],
        kexuanlist:[],
        pdcd:true,
        sjzt2:false,
        foodzt:0,
        defaultlist:[0,0],
        defaultlist2:[0],
        foods:{name:'',phone:'',dizi:'',youb:''},
        ggsq:'',
        tupan:'http://154.94.7.80',//图片地址
        ShopID:'',
        toastShow: false,
        cancen:"",
        canzt:false,
        DecimalBit:2,
        Desk:"",
        toastText: '',
        popup: 0,
        username: '显示消息提示框',
        quanxuan:false,
        addShow: false,//购物车动画
        fei_xb: 0, //分类下标
        navMenuType: 'float: left;position: absolute;', //分类样式状态
        pand:false,//详情
        cur:false,//购物车
        shangdID:'001',//商店ID
        pq:[
          {name:'',sz:[{MessyPrice:0,ID:1001}]},
          {name:'',sz:[{MessyPrice:0,ID:1001}]}
        ] ,
          //菜品列表
        feilist:[],//分类
		feilist_two:[],
		pq_two:[],
        /*语言选择*/
        pickerVisible: false,
        pickxb:2,//语言下标
        IsNewGoodsRemark:false,
        pickindex:0,
        ggxb:0,//规格下标
        gmsl:1,//购买数量
        guige:false,//判断是否有规格
        rotate:false,
        result: [],
        WXLangGoodsxb:0,
        WXLangGoods:{},
        MenuQua:0,
        scrollTop:0,
        BuffetTypeID:"",//包餐菜名
        xqxb_i:0,//下标
        xqxb_j:0,//下标
        gwcsl:0,//购物车商品数量
        gwcsl2:0,
        PayState:0,
        gwclist:[],
        sheetzt:false,
        zongji:0,//购物车价值
        curlist:[
          {name:'iPhone', jiage:1.5,sl:1,img:'../static/images/1006.jpg',zt:true,beizhu:''},
          {name:'iPhone', jiage:1.5,sl:1,img:'../static/images/1006.jpg',zt:true,beizhu:''},
          {name:'iPhone', jiage:1.5,sl:1,img:'../static/images/1006.jpg',zt:true,beizhu:''},
          {name:'iPhone', jiage:1.5,sl:1,img:'../static/images/1006.jpg',zt:false,beizhu:''}
        ],
        xq_list:[{MessyPrice:0,Unit:''}],
        jpzf:[
          {zf1:"ABAPAY",zf2:"HuionePAY",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"然后扫一扫识别二维码",zf7:"然后扫一扫识别二维码",zf8:"然后扫一扫识别二维码",zf9:"输入金额",zf11:"然后点击支付",zf12:"支付完成点击“我已支付”",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"ABAPAY",zf2:"HuionePAY",zf3:"Paypay支付",zf4:"ចម្លង",zf5:"សូម​យក​រូបថត​អេក្រង់​ដើម្បី​រក្សាទុក​កូដ QR",zf6:"ស្កេន​ដើម្បី​បញ្ជាក់​កូដ QR",zf7:"ស្កេន​ដើម្បី​បញ្ជាក់​កូដ QR",zf8:"ស្កេន​ដើម្បី​បញ្ជាក់​កូដ QR",zf9:"",zf11:"",zf12:"បន្ទាប់​មក​ចុច​លើ​ការ​ផ្តល់",zf13:"ញុំ​បាន​ផ្តល់​រួច​ហើយ",zf14:"ជ្រើស​វិធីសាស្ត្រ​ផ្តល់"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"WeChat Pay",zf2:"Alipay Pay",zf3:"Paypay Pay",zf4:"コピー",zf5:"スクリーンショットを撮ってQRコードを保存し,",zf6:"WeChat で QR コードをスキャンして識別し,",zf7:"Alipay で QR コードをスキャンして識別し,",zf8:"Paypay で QR コードをスキャンして識別し,",zf9:"金額を入力し",zf11:"お支払いください",zf12:"最後に“支払完了”ボタンをお押しください",zf13:"支払完了",zf14:"お届け住所",zf15:"お届け住所を選択する",zf16:"住所を追加する",zf17:"新しい住所を入力する",zf18:"お届け住所を入力する",zf19:"支払い方法",zf20:"詳しい情報を入力してください",zf21:"営業時間",zf22:"支払い方法を選択してください"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
          {zf1:"微信支付",zf2:"支付宝支付",zf3:"Paypay支付",zf4:"复制",zf5:"请截屏保存二维码",zf6:"在微信中扫一扫识别二维码",zf7:"在支付宝中扫一扫识别二维码",zf8:"在Paypay中扫一扫识别二维码",zf9:"输入",zf11:"然后点击支付",zf12:"支付完成点击",zf13:"我已支付",zf14:"选择支付方式"},
        ],
        ztlist:[
          {ooo:"菜品数量过多",o1:"餐台未开台请联系服务员",o2:"餐厅未接单",o3:"餐台正在结账",o4:"快餐",o11:"点餐次数超过可点次数",O12:"点菜数量大于可点数量",O13:"当前时间不在可点菜范围",o14:"点菜时间已过请重新开台"},
          {ooo:"菜品数量过多",o1:"餐台未開台请联系服务员",o2:"餐厅未接单",o3:"餐台正在結賬",o4:"外賣",o11:"点餐次数超过可点次数",O12:"点菜数量大于可点数量",O13:"当前时间不在可点菜范围",o14:"点菜时间已过请重新开台"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Online Order",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"الكثير من الأطباق",o1:"لم يفتح طاولة الطعام المحطة",o2:"لا يتلقى المطعم أوامر",o3:"طاولة الطعام يتم التحقق منها",o4:"وجبات سريعة",o11: "عدد أوقات الطلب هو أكثر من عدد النقاط.",O12:"عدد الطلبات أكبر من عدد الطلبات", O13: "الوقت الحالي غير متاح للطلب", o14: "انتهى الوقت ، يرجى إعادة فتح"},
          {ooo:"ចានច្រើនពេក",o1:"តុបរិភោគអាហារមិនបើកទេ។",o2:"ភោជនីយដ្ឋានមិនទទួលការបញ្ជាទិញ",o3:"តារាងបរិភោគអាហារកំពុងពិនិត្យមើល",o4:"អាហាររហ័ស",o11: "បញ្ជាទិញលើសពីការអនុញ្ញាត", O12: "បរិមាណបញ្ជាទិញគឺធំជាងបរិមាណបញ្ជាទិញ", O13: "ពេលវេលាបច្ចុប្បន្នមិនមានសម្រាប់ការបញ្ជាទិញទេ។", o14: "ពេលវេលាបញ្ជាទិញបានកន្លងផុតទៅហើយ សូមបើកឡើងវិញ"},
          {ooo:"demasiados platos",o1:"Mesa no habilitada",o2:"Resctaurante no ha aceptado del pedido",o3:"Resctaurante está haciendo la caja",o4:"Comida rápida",o11: "La cantidad de comidas solicitadas excede la cantidad de pedidos permitidos", O12: "La cantidad pedida es mayor que la cantidad que se puede pedir.", O13: "La hora actual no está dentro del rango de pedido", o14: "El tiempo de pedido ha pasado, por favor vuelve a abrir la mesa."},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"Te veel gerechten",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "het aantal bestellingen overschrijdt het aantal beschikbare bestellingen", O12: "het aantal bestellingen is groter dan het aantal beschikbare bestellingen", O13: "de huidige tijd ligt niet binnen het bereik van beschikbare bestellingen", o14: "de besteltijd is verlopen, alstublieft heropenen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"食べ飲み放題は１回につきお一人様３点までご注文いただけます",o1:`未配席。\nスッタフをお呼びください。`,o2:"未受注",o3:"会計中",o4:"ファストフード",o11: "注文回数オーバー", O12: "注文点数オーバー", O13: "３分毎に一回ご注文いただけますので、", o14: "タイムアウト",cf:"分ほどお待ちください。"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo:"too many dishes",o1:"Not open",o2:"Missed orders",o3:"Checking out",o4:"Fast Food",o11: "the number of orders exceeds the number of orders available", O12: "the number of orders is greater than the number of orders available", O13: "the current time is not within the range of orders available", o14: "the order time has expired, please reopen"},
          {ooo: "Terlalu banyak hidangan", o1: "Meja makan tidak terbuka", o2: "Restoran tidak menerima pesanan", o3: "Meja makan sedang check-out", o4: "Makanan cepat saji", o11: "Jumlah pesanan telah melebihi jumlah hidangan yang dapat dipesan", O12: "Jumlah hidangan yang dipesan lebih banyak dari jumlah hidangan yang dapat dipesan", O13: "Waktu saat ini tidak berada dalam kisaran hidangan yang bisa dipesan", o14: "Waktu pemesanan telah berlalu, silakan restart mejanya"},
          {ooo:"จานมากเกินไป",o1:"โต๊ะกินข้าวไม่เปิด",o2:"ทางร้านไม่รับออเดอร์",o3:"กำลังดำเนินการชำระเงินที่โต๊ะรับประทานอาหาร",o4:"อาหารจานด่วน",o11:"จำนวนอาหารที่สั่งเกินจำนวนคำสั่งซื้อที่มีอยู่",O12:"ปริมาณที่สั่งมากกว่าปริมาณที่สามารถสั่งได้",O13:"เวลาปัจจุบันไม่อยู่ในช่วงการสั่งซื้อ",o14:"หมดเวลาสั่งแล้ว กรุณาเปิดโต๊ะอีกครั้ง",cf:"min"},
          {ooo:"Πάρα πολλά πιάτα",o1:"Η τραπεζαρία δεν είναι ανοιχτή",o2:"Το εστιατόριο δεν έλαβε την παραγγελία",o3:"Το ταμείο είναι σε εξέλιξη στην τραπεζαρία",o4:"γρήγορο φαγητό",o11:"Ο αριθμός των παραγγελθέντων γευμάτων υπερβαίνει τον αριθμό των διαθέσιμων παραγγελιών",O12:"Η ποσότητα της παραγγελίας είναι μεγαλύτερη από την ποσότητα που μπορεί να παραγγελθεί",O13:"Η τρέχουσα ώρα δεν είναι εντός του εύρους παραγγελίας",o14:"Ο χρόνος παραγγελίας έχει παρέλθει. Ανοίξτε ξανά τον πίνακα"},
          {ooo:"Preveliko število elementov",o1:"Miza je zaprta",o2:"Naročilo ni sprejeto",o3:"Miza je odjavljena",o4:"Fast Food",o11:"Prevečkratno naročanje",O12:"Naročanje preveč jedi",O13:"Izven časa naročanja",o14:"Čas naročanja se je iztekel, ponovno odprite mizo.",cf:"min"},
          {ooo:"Excessive Number of Items",o1:"Table Closed",o2:"Order Not Accepted",o3:"Table Checking Out",o4:"Fast Food",o11:"Ordering Too Many Times",O12:"Over-Ordering",O13:"Out of Ordering Hours",o14:"The ordering time has expired, please reopen the table.",cf:"min"},
          {ooo:"",o1:"Çoxlu yemək",o2:"Restoran sifarişi qəbul etmədi.",o3:"Qida kassası hesabı emal edir.",o4:"fast food",o11:"Sifarişlər icazə verilən sifariş sayını aşdı.",O12:"Sifariş edilən yeməklərin sayı sifariş edilə bilən yeməklərin sayından çoxdur.",O13:"Cari vaxt sifariş verilə bilən yeməklər diapazonunda deyil.",o14:"Sifariş vaxtı keçib, zəhmət olmasa masanı yenidən açın.",cf:"min"},
          {ooo:"ဟင်းလျာများလွန်းသည်",o1:"စားပွဲဖွင့်မထားပါ",o2:"စားသောက်ဆိုင်မှ မှာယူမှုများကို လက်မခံပါ",o3:"စားပွဲသည် ငွေပေးချေမှုများကို လက်ရှိလုပ်ဆောင်နေသည်",o4:"အမြန်စားစရာ",o11:"မှာယူမှုများသည် ရရှိနိုင်သော ပမာဏထက်ကျော်လွန်နေသည်",O12:"မှာယူမှုများသည် ရရှိနိုင်သော ပမာဏထက်ကျော်လွန်နေသည်",O13:"လက်ရှိအချိန်တွင် ရရှိနိုင်သော မှာယူမှုအတိုင်းအတာပြင်ပတွင်ရှိနေသည်",o14:"မှာယူမှုအချိန်ကုန်ဆုံးသွားပါပြီ၊ ကျေးဇူးပြု၍ စားပွဲကိုပြန်ဖွင့်ပါ"},
          {ooo:"Çok fazla yemek",o1:"Masa boş değil",o2:"Restoran sipariş almıyor",o3:"Masa şu anda ödemeleri işliyor",o4:"Hızlı yemek",o11:"Siparişler mevcut miktarı aştı",O12:"Siparişler mevcut miktarı aştı",O13:"Mevcut zaman, sipariş verme aralığının dışında",o14:"Sipariş verme süresi doldu, lütfen masayı tekrar açın"},
          {ooo:"Хэт олон хоол",o1:"Хоолны ширээ онгорх",o2:"Ресторан захиалгыг х",o3:"Хоолны лангуу төлбө",o4:"түргэн хоол",o11:"Захиалгууд зөвшөөрө",O12:"Захиалсан хоолны то",O13:"Одоогийн цаг захиал",o14:"Захиалгын хугацаа ду"},
        ],
        foodlist:[
          {on1:"自取",on2:"外送",on3:"姓名",on4:"电话",on5:"邮编",on6:"地址",on7:"取餐时间",on8:"到达时间",on9:"选项必选",on10:"固定套餐",on11:"可选套餐选项",on12:"小费",on13:"菜品价格",on14:"服务费",on15:"打包费"},
          {on1:"自取",on2:"外賣",on3:"姓名",on4:"電話",on5:"郵編",on6:"地址",on7:"取餐時間",on8:"送達時間",on9:"選項必選",on10:"固定選項",on11:"套餐可選選項",on12:"小费",on13:"菜品价格",on14:"服务费",on15:"打包费"},
          {on1:"Pick Up",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zipcode",on6:"Address",on7:"Pick Up At:",on8:"ETA",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"الذاتي",on2:"توصيل",on3:"اسم",on4:"هاتف",on5:"الرمز البريدي",on6:"تبوك",on7:"حان الوقت للمتجر",on8:"وقت الوصول",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"إكرامية",on13:"سعر الطبق",on14:"رسوم الخدمة",on15:"رسوم التغليف"},
          {on1:"លើកឡើង",on2:"ការដឹកជញ្ជូន",on3:"ឈ្មោះ",on4:"ទូរស័ព្ទ",on5:"លេខកូដប្រៃសណីយ៍",on6:"អាសយដ្ឋាន",on7:"ពេលវេលាមកដល់",on8:"ពេលវេលានៃការមកដល់",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Comida para llevar con recogida propia",on2:"Comida al domicilio",on3:"Nombre",on4:"Telefono",on5:"Código postal",on6:"Dirección",on7:"Tiempo de llegada al restaurante",on8:"Hora de la llegada",on9:"Opción obligatoria",on10:"Paquete fijo",on11:"Opciones de paquete opcionales",on12:"Propina",on13:"Precio del plato",on14:"Tarifa de servicio",on15:"Tarifa de embalaje"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Afhaal",on2:"Bezorgen",on3:"Naam",on4:"Telefoonnummer",on5:"Postcode",on6:"Adres",on7:"Aankomsttijd in zaak",on8:"Aankomsttijd",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Fooi",on13:"Gerechtprijs",on14:"Servicekosten",on15:"Verpakkingskosten"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Ritiro ordine in negozio",on2:"Consegna a domicilio ",on3:"Nome",on4:"Cellulare",on5:"Codice postale",on6:"Indirizzo",on7:"Orario di ritiro",on8:"Ora di consegna",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Mancia",on13:"Prezzo piatto",on14:"Costo servizio",on15:"Costo imballaggio"},
          {on1:"テイクアウト",on2:"デリバリー",on3:"お名前",on4:"お電話番号",on5:"郵便番号",on6:"ご住所",on7:"到着時間",on8:"配達時間",on9:"選択必須",on10:"選択不可",on11:"お選びください",on12:"チップ",on13:"料理価格",on14:"サービス料",on15:"包装料"},
          {on1:"Retirada",on2:"Entrega",on3:"Nome",on4:"Telefone",on5:"CEP",on6:"Endereço",on7:"Horário de retirada",on8:"Horário de entrega",on9:"Opções obrigatórias",on10:"Combo fixo",on11:"Opções do combo",on12:"Gorjeta",on13:"Preço do prato",on14:"Taxa de serviço",on15:"Taxa de embalagem"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"pengambilan mandiri",on2:"pengiriman",on3:"nama",on4:"telepon",on5:"kode pos",on6:"alamat",on7:"waktu kedatangan",on8:"kedatangan waktu",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Harga makanan",on14:"Biaya layanan",on15:"Biaya kemasan"},
          {on1:"หยิบ",on2:"จัดส่ง",on3:"ชื่อ",on4:"โทรศัพท์",on5:"รหัสไปรษณีย์",on6:"ที่อยู่",on7:"เวลามาถึง",on8:"เวลามาถึง",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"ทิป",on13:"ราคาอาหาร",on14:"ค่าบริการ",on15:"ค่าบรรจุภัณฑ์"},
          {on1:"Σηκώνω",on2:"Διανομή",on3:"Ονομα",on4:"Τηλέφωνο",on5:"ταχυδρομικός κώδικας",on6:"διεύθυνση",on7:"Ώρα άφιξης",on8:"Ώρα άφιξης",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Φιλοδώρημα",on13:"Τιμή πιάτου",on14:"Χρέωση υπηρεσίας",on15:"Χρέωση συσκευασίας"},
          {on1:"Self-Pickup",on2:"Dostava",on3:"Ime in priimek",on4:"GSM",on5:"Poštna št.",on6:"Naslov",on7:"Čas prihoda",on8:"Čas dostave",on9:"选项必选",on10:"固定套餐",on11:"可选套餐选项",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Self-Pickup",on2:"Delivery",on3:"Name and Surname",on4:"Cell Phone",on5:"Postcode",on6:"Address",on7:"Arrival Time",on8:"Delivery Time",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Öz-özünə götürmə",on2:"Çatdırılma",on3:"",on4:"Ad",on5:"poçt kodu",on6:"ünvan",on7:"Gəliş vaxtı",on8:"Gəliş vaxtı",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Bəxşiş",on13:"Yemək qiyməti",on14:"Xidmət haqqı",on15:"Qablaşdırma haqqı"},
          {on1:"ကိုယ်တိုင်လာယူခြင်း",on2:"ပို့ဆောင်ခြင်း",on3:"အမည်",on4:"ဖုန်းနံပါတ်",on5:"ဇစ်ကုဒ်",on6:"လိပ်စာ",on7:"ရောက်ရှိချိန်",on8:"ရောက်ရှိချိန်",on9: "ရွေးချယ်စရာလိုအပ်ပါတယ်", on10: "ပုံမှန်အစီအစဉ်", on11: "ရွေးချယ်စရာအစီအစဉ်ရွေးချယ်စရာများ",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
          {on1:"Kendin al",on2:"Teslimat",on3:"İsim",on4:"Telefon numarası",on5:"Posta kodu",on6:"Adres",on7:"Varış saati",on8:"Varış saati",on9: "Seçenekler zorunlu", on10: "Sabit paketler", on11: "İsteğe bağlı paketler",on12:"Bahşiş",on13:"Yemek fiyatı",on14:"Servis ücreti",on15:"Paket ücreti"},
          {on1:"Өөрөө авах",on2:"Хүргэлт",on3:"Нэр",on4:"Утас",on5:"шуудангийн код",on6:"Хаяг",on7:"Ирэх цаг",on8:"Ирэх цаг",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Гар цай",on13:"Хоолны үнэ",on14:"Үйлчилгээний төлбөр",on15:"Савлагааны төлбөр"},
        ],
        picktan:[
          {zfzs:"选少了",zfkx:"选多了",zfbx:"做法必选",qdxd:"确定下单吗",qd:"确定",qx:"取消",sfsc:"是否删除",jiazai:"",sfhj:"呼叫服务"},
          {zfzs:"選少了",zfkx:"選多了",zfbx:"必須選擇",qdxd:"確定下單嗎",qd:"確定",qx:"取消",sfsc:"是否刪除",jiazai:"",sfhj:"呼叫服務"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Select ",qdxd:"Order Confirm",qd:"Confirm",qx:"Cancel",sfsc:"Delete",jiazai:"Loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"هل أنت متأكد من تقديم طلب؟",qd:"بالتأكيد",qx:"يلغي",sfsc:"حذف أم لا",jiazai:"جار التحميل",sfhj:"خدمة الدعوة"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"តើ​អ្នក​ប្រាកដ​ជា​ចង់​ធ្វើ​ការ​បញ្ជា​ទិញ​ឬ",qd:"ប្រាកដ",qx:"បោះបង់",sfsc:"លុបឬអត់",jiazai:"ផ្ទុកយ៉ាងខ្លាំង",sfhj:"សេវាហៅទូរស័ព្ទ"},
          {zfzs:"Hay menos opciones.",zfkx:"Hay muchas opciones.",zfbx:"Las prácticas deben ser seleccionadas",qdxd:"Confirmar el pedido",qd:"Confirmar",qx:"Cancelar",sfsc:"eliminar sí o no?",jiazai:"Cargando",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Minder geselecteerd",zfkx:"Te veel gekozen",zfbx:"Vereiste selectie",qdxd:"Bevestigen voor bestelling",qd:"Bevestigen ",qx:"Annuleren",sfsc:"Verwijderen of niet",jiazai:"Bezig met laden",sfhj:"Medewerker"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Meno scelta",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Conferma ordine",qd:"Conferma",qx:"Annulla ordine",sfsc:"Conferma o Annulla",jiazai:"Attendere",sfhj:"Call service"},
           {zfkx:"作り方をお選び下さい",zfbx:"作り方をお選び下さい",qdxd:"送信してよろしいでしょうか?",qd:"確定",qx:"取消",sfsc:"削除しますか",jiazai:"",sfhj:"御呼び"},
          {zfzs:"Selecionou menos",zfkx:"Selecionou mais",zfbx:"Opção obrigatória",qdxd:"Confirmar pedido?",qd:"Confirmar",qx:"Cancelar",sfsc:"Confirmar exclusão?",jiazai:"Carregando",sfhj:"Chamar serviço"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Czy na pewno chcesz złożyć zamówienie?",qd:"Czy na pewno",qx:"Anuluj",sfsc:"Czy go usunąć",jiazai:"załadowany rozpaczliwie",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Are you sure about the order",qd:"determine",qx:"cancel",sfsc:"Whether or not to delete",jiazai:"Hard loading",sfhj:"Call service"},
          {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd: "Apakah Anda yakin untuk melakukan pemesanan?", qd: "Konfirmasi", qx: "Batal", sfsc: "Hapus", jiazai: "", sfhj: "Layanan panggilan"},
          {zfzs:"เลือกน้อย",zfkx:"ตัวเลือกส่วนใหญ่",zfbx:"การปฏิบัติที่จำเป็น",qdxd:"คุณแน่ใจหรือว่าจะสั่งซื้อ?",qd:"แน่นอน",qx:"ยกเลิก",sfsc:"ไม่ว่าจะลบ.",jiazai:"",sfhj:"บริการโทร"},
          {zfzs:"Λιγότερη επιλογή",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Είστε σίγουροι ότι θα κάνετε μια παραγγελία;",qd:"Σίγουρος",qx:"Ματαίωση",sfsc:"Είτε θα διαγραφεί",jiazai:"",sfhj:"υπηρεσία κλήσης"},
          {zfzs:"Izbrano manj",zfkx:"Najbolj izbrane metode",zfbx:"Obvezno",qdxd:"Potrdite naročilo?",qd:"OK",qx:"Prekličite",sfsc:"Ali želite izbrisati?",jiazai:"",sfhj:"Klicni servis"},
          {zfzs:"Selected less",zfkx:"The best way to choose",zfbx:"Practice mandatory",qdxd:"Confirm your order?",qd:"OK",qx:"Cancel",sfsc:"Want to delete?",jiazai:"",sfhj:"Call Service"},
          {zfzs:"Selected less",zfkx:"Əksər seçimlər",zfbx:"Tələb olunan metod",qdxd:"Sifariş vermək istədiyinizə əminsinizmi",qd:"Əlbəttə",qx:"Ləğv et",sfsc:"Silinsin",jiazai:"",sfhj:"Zəng xidməti"},
		  {zfzs:"ရွေးချယ်မှုနည်းပါတယ်",zfkx: "ရွေးချယ်မှုပိုပါတယ်",zfbx: "လုပ်ဆောင်မှုရွေးချယ်ရမည်",qdxd: "မှာယူချက်သေချာလား",qd:"OK",qx:"ဖျက်သိမ်း",sfsc:"ဖျက်သိမ်းမလား",jiazai:"",sfhj:"ခေါ်ဆိုမှုဝန်ဆောင်မှု"},
		  {zfzs:"Daha az seçildi",zfkx:"Daha fazla seçildi",zfbx:"Seçim zorunlu",qdxd:"Tamam mı",qd:"Tamam mı",qx:"İptal",sfsc:"Sildi mi",jiazai:"",sfhj:"Arama hizmetleri"},
		  {zfzs:"Selected less",zfkx:"Choose the most methods",zfbx:"Method must be selected",qdxd:"Захиалга баталгаажуу",qd:"Тэгэлгүй яахав",qx:"Цуцлах",sfsc:"Устгах уу?",jiazai:"",sfhj:"Дуудлагын үйлчилгээ"},
        ],
        pickData:[
          {label:''},
          {label:''},
          {label:''}
        ],
        pickyan:[
          {min:"分钟",th:"台号",sy:"剩余",sp:'订单',gwc:'购物车',ct:'餐厅',ddjd:'等待餐厅接单',phone:"请输入你的手机号码"},
          {min:"分鐘",th:"台號",sy:"剩餘",sp:'訂單',gwc:'購物車',ct:'餐廳',ddjd:'等待餐廳接單',phone:"請輸入電話號碼"},
          {min:"M",th:"Table",sy:"Residue",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Input phone"},
          {min:"M",th:"台号",sy:"剩余",sp:'ترتيب',gwc:'عربة التسوق',ct:'غرفة العشاء',ddjd:'في انتظار تلقي المطعم أوامر',phone:"الرجاء إدخال رقم هاتفك المحمول"},
          {min:"M",th:"台号",sy:"剩余",sp:'បញ្ជាទិញ',gwc:'បានជ្រើសរើស',ct:'បន្ទប់បរិភោគអាហារ',ddjd:'រង់ចាំភោជនីយដ្ឋានទទួលការបញ្ជាទិញ',phone:"សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។"},
          {min:"Min",th:"Número",sy:"Excedente",sp:'Pedido',gwc:'Cesta de pedido',ct:'Restaurante',ddjd:'Esperando pedidos',phone:"Tecle por favor Telefono"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"T",sy:"Resterende",sp:'Geschiedenis',gwc:'Winkelwagen',ct:'Restaurant',ddjd:'Wachten op bestelling',phone:"Voer uw gsm-nummer in"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'Ordine',gwc:'Carrello',ct:'Negozio',ddjd:'Procedi con l’ordine',phone:"Digitate il numero del cellulare, per piacere"},
          {min:"分",th:"テーブル番号",sy:"残り",sp:'注文履歴',gwc:'カート',ct:'レストラン',ddjd:'受注待ち',phone:"お電話番号入力"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"M",th:"台号",sy:"剩余",sp:'Zamówienie',gwc:'wózek sklepowy',ct:'restauracja',ddjd:'Oczekiwanie na przetworzenie',phone:"Proszę wprowadzić swój numer telefonu komórkowego"},
          {min:"M",th:"台号",sy:"剩余",sp:'The order',gwc:'Shopping Cart',ct:'restaurant',ddjd:'Waiting to be processed',phone:"Please enter your mobile phone number"},
          {min:"menit",th:"nomor stasiun",sy:"sisa",sp:'pesanan',gwc:'keranjang belanja',ct:'restoran',ddjd:'menunggu restoran menerima pesanan' ,telepon:"Silakan masukkan nomor ponsel Anda"},
          {min:"นาที",th:"หมายเลขสถานี",sy:"ที่เหลืออยู่",sp:'คำสั่ง',gwc:'ตะกร้าสินค้า',ct:'ห้องรับประทานอาหาร',ddjd:'รอร้านอาหารรับออเดอร์ค่ะ',phone:"กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ"},
          {min:"λεπτό",th:"Αριθμός σταθμού",sy:"Παραμένων",sp:'Παραγγελία',gwc:'καλάθι αγορών',ct:'Τραπεζαρία',ddjd:'Περιμένετε το εστιατόριο να λάβει την παραγγελία σας',phone:"Εισαγάγετε τον αριθμό του κινητού σας τηλεφώνου"},
          {min:"minuta",th:"postaja št.",sy:"Preostalo",sp:'Naročilo',gwc:'Voziček',ct:'Restavracija',ddjd:'Čakanje na prejem naročila ',phone:"Prosimo, vnesite svojo št. GSM."},
          {min:"minutes",th:"Station number",sy:"Remaining:",sp:'Order for goods',gwc:'Shopping cart',ct:'Dining room',ddjd:'Waiting for the restaurant to take the order',phone:"Please enter your cell phone №."},
		  {min:"dəqiqə",th:"Platforma nömrəsi",sy:"Qalan",sp:"Sifariş",gwc:"alış-veriş səbəti",ct:"Yemək otağı",ddjd:"Restoranın sifarişi qəbul etməsini gözləyirəm",phone:"Zəhmət olmasa, mobil telefon nömrənizi daxil edin."},
		  {min:"မိနစ်",th:"စားသောက်ဆိုင်နံပါတ်",sy:"ကျန်ရှိ",sp:"စာရင်း",gwc:"စျေးဝယ်စရိတ်",ct:"စားသောက်ဆိုင်",ddjd:"စားသောက်ဆိုင်နံပါတ်ကိုစောင့်ဆိုင်း",phone:"ကျေးဇူးပ"},
		  {min:"dakika",th:"mesaj numarası",sy:"kalan",sp:"sipariş",gwc:"alışveriş sepeti",ct:"restoran",ddjd:"restoran siparişini bekliyor",phone:"lütfen cep telefonu numaranızı girin"},
		  {min:"минут",th:"Хоолны ширээ захиал",sy:"Үлдсэн",sp:"Захиалга",gwc:"дэлгүүрийн сагс",ct:"Хоолны өрөө",ddjd:"Захиалга хүлээж байн",phone:"Гар утасны дугаараа  "},
        ],
        pickn:[
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"请输入",bzxx:"自定义备注",qsrbz:"请输入备注",bz:"备注",qx:"全选",hj:"合计",xd:"下单"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"請輸入",bzxx:"自定义备注",qsrbz:"請輸入備註",bz:"備註",qx:"全選",hj:"合計",xd:"下單"},
          {bh:"Pre-tax",dw:"share",qb:"All",hs:"Tax",qsr:"Input",bzxx:"Note",qsrbz:"Special Instruction",bz:"note",qx:"Subtotal",hj:"Total",xd:"Place Order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"تفضل",bzxx:"ملاحظة مخصصة",qsrbz:"الرجاء إدخال الملاحظات",bz:"ملاحظة",qx:"اختر الكل",hj:"المجموع",xd:"ترتيب"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"សូមបញ្ចូល",bzxx:"កំណត់ចំណាំផ្ទាល់ខ្លួន",qsrbz:"សូមបញ្ចូលកំណត់ចំណាំ",bz:"ចំណាំ",qx:"ជ្រើសរើស​ទាំងអស់",hj:"សរុប",xd:"ដាក់បញ្ជា"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Tecle por favor",bzxx:"Observación",qsrbz:"Tecle por favor Observación",bz:"Observación",qx:"Seleccionar todo",hj:"En total",xd:"Hacer el pedido"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"Before tax",dw:"Qua",qb:"ALL",hs:"Tax",qsr:"Invullen",bzxx:"aangepaste notities",qsrbz:"Voer een notitie in",bz:"Opmerking",qx:"Alles selecteren",hj:"Totaal",xd:"Bestelling plaatsen"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"prego entra",bzxx:"Note",qsrbz:"Si prega di inserire una nota",bz:"Note",qx:"seleziona tutto",hj:"Totale",xd:"Conferma ordine"},
          {bh:"税抜",dw:"本~",qb:"すべて",hs:"税込",qsr:"商品名検索",bzxx:"備考",qsrbz:"備考",bz:"備考",qx:"全て選択",hj:"合計",xd:"送信"},
          {bh:"税前",dw:"unidade",qb:"Todos",hs:"Taxa incluída",qsr:"Digite",bzxx:"Observação personalizada",qsrbz:"Digite uma observação",bz:"Observação",qx:"Selecionar tudo",hj:"Total",xd:"Fazer pedido"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Proszę wpisać",bzxx:"Pełna pojedyncza nuta",qsrbz:"Proszę wpisać notatkę",bz:"Uwaga",qx:"Zaznacz wszystko",hj:"Całkowity",xd:"Złożyć zamówienie"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr: "Silakan masukkan", bzxx: "Keterangan yang disesuaikan", qsrbz: "Silakan masukkan keterangan", bz: "Keterangan", qx: "Pilih semua", hj: "Total", xd: "Lakukan pemesanan"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"กรุณาเข้า",bzxx:"บันทึกที่กำหนดเอง",qsrbz:"กรุณาใส่ข้อสังเกต",bz:"หมายเหตุ",qx:"เลือกทั้งหมด",hj:"ทั้งหมด",xd:"สั่งซื้อ"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Παρακαλώ εισάγετε",bzxx:"Προσαρμοσμένες σημειώσεις",qsrbz:"Παρακαλώ εισάγετε παρατηρήσεις",bz:"Παρατήρηση",qx:"Επιλέξτε όλα",hj:"σύνολο",xd:"Κάντε μια παραγγελία"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Prosimo, vpišite ...",bzxx:"Opombe po meri",qsrbz:"Vnesite komentar",bz:"Opombe",qx:"Izberite Vse",hj:"Skupaj",xd:"Oddate naročilo"},
          {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter",bzxx:"Custom remarks",qsrbz:"Please enter remarks",bz:"Notes",qx:"Select All",hj:"Total",xd:"Place Your Order"},
		  {bh:"Pre-tax",dw:"~",qb:"all",hs:"tax",qsr:"Zəhmət olmasa daxil edin",bzxx:"Xüsusi ehtiyat nüsxəsi",qsrbz:"Zəhmət olmasa, qeyd daxil edin.",bz:"Qeyd",qx:"Hamısını Seçin",hj:"cəmi",xd:"Sifariş verin"},
		  {bh:"Pre-tax",dw:"စာရင်း",qb:"အားလုံး",hs:"အခွန်ပါဝင်",qsr:"ထည့်ပါ",bzxx:"စိတ်ကြိုက်မှတ်ချက်",qsrbz:"မှတ်ချက်ထည့်ပါ",bz:"မှတ်ချက်",qx:"အားလုံးရွေးချယ်ပါ",hj:"စုစုပေါင်း",xd:"စာရင်း"},
		  {bh:"Pre-tax",dw:"adetten itibaren",qb:"tümü",hs:"kdv dahil",qsr:"lütfen girin",bzxx:"özel not",qsrbz:"lütfen not girin",bz:"not",qx:"hepsini seç",hj:"toplam",xd:"sipariş verin"},
		  {bh:"Pre-tax",dw:"share",qb:"All",hs:"Tax",qsr:"Оруулна уу",bzxx:"Захиалгат тэмдэглэл",qsrbz:"Тэмдэглэл оруулна уу.",bz:"Тайлбар",qx:"Бүгдийг сонгох",hj:"нийт",xd:"Захиалга өгөх"},
        ],
        zfpicknr:"",
        zfpick:[
          {qrsx:"二维码已经过期请重新扫描二维码",yysj:"不在营业时间",gq:"此二维码已经过期",qxzzf:"请选择做法",ctxx:"信息",kkry:"空空如也",tjcg:"添加成功"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"不在營業時間",gq:"二維碼已經過期",qxzzf:"請選擇做法",ctxx:"信息",kkry:"空",tjcg:"添加成功"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please pick method",ctxx:"information",kkry:"null",tjcg:"Successfully Added"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"الرجاء اختيار الممارسة",ctxx:"معلومات المطعم",kkry:"إلى جانب",tjcg:"اضيف بنجاح"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"សូមជ្រើសរើសការអនុវត្តមួយ។",ctxx:"ព័ត៌មានភោជនីយដ្ឋាន",kkry:"ទទេ",tjcg:"បានបន្ថែមដោយជោគជ័យ"},
          {qrsx:"El Código QR ha caducado, vuelva a escanear el Código.",yysj:"It's not business hours yet",gq:"Este Código QR ha expirado",qxzzf:"Please select the method",ctxx:"information",kkry:"No exsisten detalles",tjcg:"Agregado exitosamente"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"De QR-code is verlopen. Scan de QR-code opnieuw.",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Kies de opmerking",ctxx:"Gegevens",kkry:"Leeg",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Succesvol toevoegen"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Si prega di scegliere il metodo",ctxx:"Chi siamo",kkry:"Vuoto",tjcg:"Già aggiunto"},
          {qrsx:"注文QRコードの有効期限が切れています。もう一度スキャンしてください。",gq:"売り切れ",qxzzf:"作り方選択",ctxx:"お会計",kkry:"データがありません。",tjcg:"追加しました"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"Informacje o restauracji",kkry:"null",tjcg:"Dodaj do sukcesem"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq: "Kode QR ini telah kedaluwarsa", qxzzf: "Silakan pilih metode", ctxx: "Informasi restoran", kkry: "Kosong", tjcg: "Berhasil ditambahkan"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"จานได้รับการประเมินแล้ว",qxzzf:"กรุณาเลือกวิธีการ",ctxx:"ข้อมูลร้านอาหาร",kkry:"ว่างเปล่า",tjcg:"เพิ่มเรียบร้อยแล้ว"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"Αυτός ο κωδικός QR έχει λήξει",qxzzf:"Επιλέξτε τη μέθοδο",ctxx:"Πληροφορίες εστιατορίου",kkry:"Αδειάζω",tjcg:"Προστέθηκε με επιτυχία"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"Jedi so ocenjene",qxzzf:"Prosimo, izberite želeno(-e) ...",ctxx:"Informacije o restavraciji",kkry:"prazno",tjcg:"Uspešno dodano"},
          {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"The dishes have been assessed",qxzzf:"Please select preference(s) ...",ctxx:"Restaurant Info",kkry:"It's empty",tjcg:"Added Successfully"},
		  {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"Yeməklər satılıb qurtarıb.",qxzzf:"Zəhmət olmasa, metodu seçin",ctxx:"Restoran Məlumatı",kkry:"Boş",tjcg:"Uğurla əlavə edildi"},
		  {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"This QR code has expired",qxzzf:"Please select the method",ctxx:"information",kkry:"null",tjcg:"Add successful"},
		  {qrsx:"QR kodu süresi dolmuş lütfen QR kodunu tekrar tarayın",yysj:"iş saatinde değil",gq:"bu QR kodu süresi dolmuş",qxzzf:"lütfen bir yöntem seçin",ctxx:"bilgi",kkry:"boş",tjcg:"ekleme başarılı"},
		  {qrsx:"二维码已经失效请重新扫码",yysj:"It's not business hours yet",gq:"Энэ QR кодын хугацаа дууссан байна.",qxzzf:"Арга сонгоно уу",ctxx:"Рестораны мэдээлэл",kkry:"Хоосон",tjcg:"Амжилттай нэмэгдлээ"},
        ],
        tableid:'',
        IsBuffet:0,
        DeskMin:"0",
        pickxq:[
          {fh:'返回',spxq:'商品详情',sl:'数量',qxzgg:'请选择规格',jrgwc:'加入购物车',yx:'已选',qxzzf:'请选择做法'},
          {fh:'返回',spxq:'商品詳情',sl:'數量',qxzgg:'请选择规格',jrgwc:'加入購物車',yx:'已選',qxzzf:'請選擇做法'},
          {fh:'Back',spxq:'Order Detail',sl:'Quantity',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'Picked',qxzzf:'Please pick'},
          {fh:'إرجاع',spxq:'تفاصيل المنتج',sl:'كمية',qxzgg:'الرجاء تحديد المواصفات',jrgwc:'أضفها الى قائمة المشتريات',yx:'المحدد',qxzzf:'الرجاء اختيار الممارسة'},
          {fh:'ដកថយ',spxq:'ព​ត៌​មាន​លម្អិត​នៃ​ផលិតផល',sl:'បរិមាណ',qxzgg:'សូមជ្រើសរើសការបញ្ជាក់',jrgwc:'បន្ថែមទៅរទេះទិញទំនិញ',yx:'បានជ្រើសរើស',qxzzf:'សូមជ្រើសរើសការអនុវត្តមួយ។'},
          {fh:'Volver',spxq:'Detalles del producto',sl:'Cantidad',qxzgg:'Por favor seleccione especificaciones',jrgwc:'añadir al carrito',yx:'Seleccionado',qxzzf:'Seleccione el método de cocina'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'Terug',spxq:'Productdetails',sl:'Aantal',qxzgg:'Kies specificatie',jrgwc:'Toevoegen in winkelwagen',yx:'Geselecteerd',qxzzf:'Kies de opmerking'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'Indietro',spxq:'Informazioni sul prodotto',sl:'quantità',qxzgg:'Si prega di selezionare le specifiche',jrgwc:'Già aggiunto al carrello',yx:'Già scelto ',qxzzf:'Si prega di scegliere il metodo'},
          {fh:'戻り',spxq:'商品情報',sl:'数量',qxzgg:'選択項目',jrgwc:'カート',yx:'選択済み',qxzzf:'作り方選択'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'powrót',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'powrót',spxq:'Product details',sl:'The number of',qxzgg:'Please select specification',jrgwc:'Add to Cart',yx:'The selected',qxzzf:'请选择做法'},
          {fh:'return',spxq:'detail produk',sl:'jumlah',qxzgg:'silakan pilih spesifikasi',jrgwc:'tambahkan ke keranjang belanja',yx:'dipilih',qxzzf:'silakan pilih metode'},
          {fh:'กลับ',spxq:'รายละเอียดสินค้า',sl:'ปริมาณ',qxzgg:'กรุณาเลือกข้อมูลจำเพาะ',jrgwc:'เพิ่มลงในรถเข็น',yx:'เลือกแล้ว',qxzzf:'กรุณาเลือกวิธีการ'},
          {fh:'απόδοση',spxq:'Λεπτομέρειες προϊόντος',sl:'ποσότητα',qxzgg:'Επιλέξτε προδιαγραφές',jrgwc:'προσθέστε στο καλάθι',yx:'Επιλεγμένο',qxzzf:'Επιλέξτε τη μέθοδο'},
          {fh:'Nazaj',spxq:'Podrobnosti o izdelku',sl:'Količina',qxzgg:'Prosimo, izberite specifikacijo(-e) ...',jrgwc:'Dodajte v košarico',yx:'Izbrani',qxzzf:'Prosimo, izberite želeno(-e) ...'},
          {fh:'Back',spxq:'Item Details',sl:'Quantity',qxzgg:'Please select spec(s) ...',jrgwc:'Add to Cart',yx:'Selected',qxzzf:'Please select preference(s) ...'},
		  {fh:'qayıtmaq',spxq:'Məhsul Təfərrüatları',sl:'miqdar',qxzgg:'Zəhmət olmasa, spesifikasiyaları seçin',jrgwc:'səbətə əlavə et',yx:'Seçilmiş',qxzzf:'Zəhmət olmasa, etmək üçün seçin'},
          {fh:'ပြန်သွား',spxq:'ပစ္စည်းအချက်အလက်',sl:'အရေအတွက်',qxzgg:'သတ်မှတ်ချက်များကိုရွေးချယ်ပါ',jrgwc:'စျေးဝယ်စရိတ်ထဲသို့ထည့်သွင်း',yx:'ရွေးချယ်ထားသည်',qxzzf:'ရွေးချယ်ထားသည်'},
		  {fh:'Geri Dön',spxq:'Ürün Detayı',sl:'Miktar',qxzgg:'Lütfen boyut seçin',jrgwc:'Sepete Ekle',yx:'Seçilen',qxzzf:'Lütfen yapım seçin'},
		  {fh:"буцах",spxq:"Бүтээгдэхүүний дэлгэ",sl:"тоо хэмжээ",qxzgg:"Үзүүлэлтүүдийг сонго",jrgwc:"Сагсанд нэмэх",yx:"Сонгосон",qxzzf:"Арга сонгоно уу"},
        ],
        /*小球*/
        xq_la:[{Remark:''}],
        xq_la2:[],
        xq_la_xb:-1,
        swiperOption: {
          //loop: true,
          direction: 'vertical',
          slidesPerView: 'auto',
        },
        swiperOption2: {
                observeParents:true,
                pagination: '.swiper-pagination',
                paginationClickable: true,    //分页可点击
                slidesPerView: 1,    //每次滑动图片一张
                    slidesPerGroup: 1,    //每个div只有一张图片
                loop: true,        //false 不循环    true循环
                // grabCursor: true,  //鼠标光标
                    autoplay: {
                      delay: 5000,    //秒
                      stopOnLastSlide: false,
                        disableOnInteraction: false,//滑动不会失效
                    },
        },
        show: false,
        num: 0, //控制角度
        rightNum: 20,
        goodsNum: 0,
        subStyle: {
        right: '20px',
        bottom: '20px',
        opacity: 0,
        transform: 'rotate(0deg)',
        lsxb:0,
        MoneySymbol:'',
        Numberpoints:"",
      },
      id: null, //定时器的id
      balls: [
        // 这里定义了多个ball,是因为可能同时有多个小球在动画中（快速点击多次或者多个商品）
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        },
        {
          show: false
        }
      ],
      dropBalls: []
      }
    },
    props:{
        bgcolor: { // 小球颜色
          type: String,
          default: 'orange'
        },
        imgurl: String, //商品图片
        title: String, //商品标题
        price: Number, //商品价格
        addnum: Number //添加商品的数据
      },
    destroyed: function () {
      var that=this
      that.axios.get(that.$lujin+"/api/Default/PosError?ShopID="+that.ShopID+"&DeskID="+that.tableid+"&Content=4")
      .then(res=>{})
    },
    methods: {
      bzjr:function(){
        if(JSON.parse(localStorage.getItem(this.ShopID+'list'))){
          var sql=JSON.parse(localStorage.getItem(this.ShopID+'list'))
        }else{
          var sql=[]
        }
        console.log(this.pq[this.xqxb_i].sz[this.xqxb_j])
        console.log(sql)
        var sum=""
        for(var i in sql){
          if(sql[i].id==this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID){
            sum=i
          }
        }
        if(sum!="")
          sql[sum].bz=this.pq[this.xqxb_i].sz[this.xqxb_j].bz||''
        localStorage.setItem(this.ShopID+'list', JSON.stringify(sql));
        if(this.IsNewGoodsRemark){
          this.jiaclick22()
        }else{
          this.jiaclick2()
        }
        //this.xqesc();
      },
      datasj:function(){
        var myDate = new Date();
        var shi=myDate.getHours(),fen=parseInt(myDate.getMinutes()/5)+1
        console.log(shi,fen)
        if(fen==12){
          shi+=1
          fen=0
        }if(shi==24){
          shi=0
        }
        console.log(shi,fen)
        this.defaultlist=[shi,fen]
        this.sjzt=true
      },
      confirm2:function(res){
        //console.log(res)
        if(res[0])
          this.data_s=res[0].label
        if(res[1])
          this.data_f=res[1].label
      },
      tiaoclick:function(){
        //console.log(1111111)
        this.$router.push("/Qua?ShopID="+this.ShopID+"&DeskID="+this.tableid);
      },
      tiaoclick2:function(){
        //console.log(1111111)
        this.$router.push("/qwe?ShopID="+this.ShopID+"&DeskID="+this.tableid);
      },
      yydj:function(){
        this.pdcd=!this.pdcd;
        this.yyds();
      },
      hjclick(){
        var that=this
        this.$dialog({
          title:that.picktan[that.pickxb].sfhj,
          cancelBtnTxt:that.picktan[that.pickxb].qx,
          okBtnTxt:that.picktan[that.pickxb].qd,
          onOkBtn() {
            console.log(1235451)
            this.close(); //关闭对话框
            var sbdata=new Date();
            var data={
              ShopID:that.ShopID,
              DeskID:that.tableid,
              Time:sbdata.getFullYear()+"-"+(sbdata.getMonth()+1)+"-"+sbdata.getDate()+" "+sbdata.getHours()+":"+sbdata.getMinutes()+":"+sbdata.getSeconds()
            }
            console.log(data)
            that.axios.post(that.$lujin+"/api/Default/Callservice",data).then((res)=>{
              console.log(res)
            })
          },
        });
      },
      sstext(){
        return
        if(this.stext=="")
        return;
        localStorage.setItem("shuju",JSON.stringify(this.pq))
        this.$router.push("/ss?Shopid="+this.ShopID+"&id="+this.tableid+"&context="+this.stext);
      },
      kxclick(i){
        console.log(this.kexuanlist)
        console.log(this.kexuanlist[i].IsFixup)
        if(this.kexuanlist[i].IsFixup=="1"){
          return
        }
      	this.IsSetMealzt=true
      	this.IsSetMealxb=i
      	this.setlists=this.kexuanlist[i]
      },
      kxclick2(){
        console.log(this.Qlist)
      	this.IsSetMealzt=false
        this.kexuanlist[this.IsSetMealxb]=this.setlists
      },
	  Depotclick(xb){
		  this.MadeDepotlistxb=xb
		  console.log(this.feilist_two)
		  if(xb==0){
			  this.feiclick(0,false)
			  this.pq=this.pq_two
			  this.feilist=this.feilist_two
		  }else{
			  this.pq=[]
			  this.feilist=[]
			  for(var i=0;i<this.feilist_two.length-1;i++){
				  if(this.feilist_two[i].MadeDepotID==this.MadeDepotlist[xb-1].MadeDepotID){
					  this.feilist.push(this.feilist_two[i])
					  this.pq.push(this.pq_two[i])
					  this.feiclick(0,false)
				  }
			  }
			  if(this.feilist.length>0){
				  this.feilist.push(this.feilist[this.feilist.length-1])
				  this.pq.push(this.pq[this.pq.length-1])
			  }
			  console.log(this.pq)
			  console.log(this.feilist)
		  }
	  },
      yyds(){
          if(!this.pdcd){
            document.getElementsByClassName("navMenuType")[0].style.display="none";
            document.getElementsByClassName("goodsBigDiv")[0].style.width="100%"
          }
          else{
            document.getElementsByClassName("goodsBigDiv")[0].style.width="70%"
            document.getElementsByClassName("navMenuType")[0].style.display="block";
          }
      },
      phoneclick:function(){
        this.PhoneState=false
        if(this.phonetext==""){
          return
        }
        document.documentElement.scrollTop=0;
        var url=this.$route.query.Number?"/dd?Shopid="+this.ShopID+"&id="+this.tableid+"&Phone="+this.phonetext+"&Number="+this.$route.query.Number:"/dd?Shopid="+this.ShopID+"&id="+this.tableid+"&Phone="+this.phonetext
        this.$router.push(url);
      },
      ddclick:function(){
        let a=""
        if(this.tableid=="Food"){
          this.PhoneState=true
          this.phonetext=""
        }else{
          document.documentElement.scrollTop=0;
          this.$router.push("/QX?ShopID="+this.ShopID+"&DeskID="+this.tableid+"&Phone="+a);
        }
      },
      kxcpclick:function(j,pd,i){
        console.log(this.kexuanlist[i])
        if(pd==0){
          var list = this.kexuanlist[i]
          if (list.list[j].Qua >= 1) {
            list.sl=parseInt(list.sl) - 1
            list.list[j].Qua= parseInt(list.list[j].Qua)-1
            if(list.list[j].Qua==0){
              list.list[j].zt = false
              for(var o in this.Qlist){
                if(this.Qlist[o].ID==list.list[j].ID){
                  this.Qlist.splice(o, 1)
                }
              }
            }else if(list.list[j].Qua>0){
              for(var o in this.Qlist){
                if(this.Qlist[o].ID==list.list[j].ID){
                  this.Qlist[o].Qua=list.list[j].Qua
                }
              }
            }
          	this.setlists = list
          }
        }else if(pd==1){
          var list = this.kexuanlist[i]
          if (list.sl < list.MaxSelItems) {
            console.log(list.list)
          	list.sl=parseInt(list.sl) + 1
          	list.list[j].Qua= (parseInt(list.list[j].Qua)?parseInt(list.list[j].Qua):0)+1
          	list.list[j].zt = true
            if(list.list[j].Qua==1){
              this.Qlist.push(list.list[j])
            }else if(list.list[j].Qua>1){
              for(var o in this.Qlist){
                if(this.Qlist[o].ID==list.list[j].ID){
                  this.Qlist[o].Qua=list.list[j].Qua
                }
              }
            }
          	//
          	this.kexuanlist.list = list
          }
        }
        return;
      	if (this.setlists.IsFixup==1) { //固定做法
      		return;
      	} else {
      		var list = this.setlists
      		if(!list.list[j].zt){//未选择
      			if (list.sl < list.MaxSelItems) {
      				list.sl += 1
      				list.list[j].zt = true
      				this.Qlist.push(list.list[j])
      				this.setlists = list
      			}
      		}else{
      			list.sl -= 1
      			list.list[j].zt = false
      			list.list[j].Zuofa = ""
            for(var i in this.Qlist){
              if(this.Qlist[i].zt==false){
                this.Qlist.splice(i, 1)
              }
            }
      			this.setlists = list
      		}
      	}
      },
      jiazai(state){
          var that=this
          this.ShopID=this.$route.query.Shopid             //获取店家id
          this.tableid=this.$route.query.id           //获取桌子id
          if(localStorage.getItem(this.$route.query.Shopid+'pickindex'))//判断语音下标
            that.pickindex=localStorage.getItem(this.$route.query.Shopid+'pickindex')
          this.axios.post(that.$lujin+"/api/Default/Parameter?ShopID="+that.ShopID).then((res)=>{
            console.log(res)
            console.log(res.data.data[0])
            console.log(res.data.data[0].DecimalBit)
            that.MoneySymbol=res.data.data[0].MoneySymbol
            that.Shop=res.data.data[0].Shop
            that.Address=res.data.data[0].Address
            that.DecimalBit=res.data.data[0].DecimalBit
            that.IsNewGoodsRemark=res.data.data[0].IsNewGoodsRemark
            that.IsMadeDepot=res.data.data[0].IsMadeDepot
            that.IsNeedServer=res.data.data[0].IsNeedServer
            that.IsTaxIncluded=res.data.data[0].IsTaxIncluded
			if(that.IsMadeDepot){
				that.axios.get(that.$lujin+"/api/Default/MadeDepot?ShopID="+that.ShopID).then((ress)=>{
				  console.log(ress)
				  that.MadeDepotlist=ress.data
				})
			}
            var szss=res.data.data[0]
            var pq3="",pq4=""
            for(var i in szss.InDineSatrtTime){
              if(i>10){
                pq4+=szss.TakeOutEndTime[i]
                pq3+=szss.TakeOutSatrtTime[i]
              }
            }
            var dangqian=new Date("1900/01/01 "+new Date().getHours()+":"+new Date().getMinutes()+":"+new Date().getSeconds())
            var kaishi=new Date("1900/01/01 "+pq3)
            var jieshu=new Date("1900/01/01 "+pq4)
            console.log(dangqian)
            console.log(kaishi)
            console.log(jieshu)
            if(this.$route.query.id=="Food"){
              if(dangqian<jieshu&&dangqian>kaishi){
                console.log("正常")
              }else{
                this.sheetzt=true
                this.zfpicknr=this.zfpick[this.pickxb].yysj
              }
            }
            console.log(pq3,pq4)
          })
          if(this.$route.query.id!="Food"){
            this.axios.post(that.$lujin+"/api/default/TDeskzt?ShopID="+this.$route.query.Shopid+"&DeskID="+this.$route.query.id)
            .then((res)=>{
              console.log(res)
              console.log(res.data[0])
              console.log(this.$route.query.SheetID)
              this.MenuQua=res.data[0].MenQua
              if(this.$route.query.SheetID==undefined){
                console.log("普通")
              }
              if(this.$route.query.SheetID==res.data[0].SheetID){
                console.log("有效期")
              }
              if(this.$route.query.SheetID!=undefined&&this.$route.query.SheetID!=res.data[0].SheetID){
                this.sheetzt=true
                this.zfpicknr=this.zfpick[this.pickxb].gq
                console.log("失效")
              }
              that.IsBuffet=res.data[0].IsBuffet
              that.IsBuffetzt=res.data[0].IsBuffet
              that.BuffetTypeID=res.data[0].BuffetTypeID
              that.Numberpoints=res.data[0].Numberpoints
			  that.axios.get(that.$lujin+"/api/Default/BuffetTypeToGoodsItems?ShopID="+that.ShopID)
				.then((sbs)=>{
					console.log(that.BuffetTypeID)
					console.log(123123123123555555)
					console.log(sbs.data.Data)
					var ksz=[]
					for(var hgs in sbs.data.Data){
						if(sbs.data.Data[hgs].BuffetGoodsTypeID==that.BuffetTypeID){
							sbs.data.Data[hgs].Qua=0
							ksz.push(sbs.data.Data[hgs])
						}
					}
					that.buffsz=ksz
				})
              that.danji(state)  //获取类别菜品信息
            })
          }else{
            that.danji(state)
          }        //获取商品列表
          setTimeout(function(){
            document.getElementById("loader-wrapper").style.display="none"
          },1200)
          window.addEventListener("scroll",this.handleScroll,false);//屏幕滑动触发
          /*处理购物车*/
          //console.log(localStorage.getItem('pickxb'))
          if(localStorage.getItem(this.ShopID+'list')){
            var ojb=JSON.parse(localStorage.getItem(this.ShopID+'list'))
            //console.log(ojb)
            var sum=0
            for(var i in ojb){
              sum+=ojb[i].sl
            }
            this.gwclist=ojb
            this.gwcsl=sum
          }
          /*(；′⌒`)*/
          var sz=[
          {"label":"简体中文","id": 1},//中文
          {"label":"繁體中文","id": 2},//繁体
          {"label":"English","id": 3},//英语
          {"label":"عربي ،","id": 4},         //阿拉伯语
          {"label":"ភាសាខ្មែរ","id":5},    //柬埔寨高棉语
          {"label":"Español","id":6}, //西班牙语
          {"label":"Срб","id":7},     //塞尔维亚语
          {"label":"Nederlands","id":8},//河南语
          {"label":"Français","id":9},//法语
          {"label":"Italiano","id":10},//意大利语
          {"label":"日本語","id":11},//日语
          {"label":"Português","id":12},//葡萄牙语
          {"label":"ViệtName","id":13},//越南语
          {"label":"Deutsch","id":14},//德语
          {"label":"한국어","id":15},//韩语
          {"label":"ກະຣຸນາ","id":16},//老挝语
          {"label":"русский язык ","id":17},//俄罗斯语
          {"label":"Norsk",id:18},//挪威语
          {"label":"Polski",id:19},//波兰语
          {"label":"Pilipino",id:20},//菲律宾语
          {"label":"Indonesian",id:21},//印尼语
          {"label":"ภาษาไทย",id:22},//泰语语
          {"label":"Ελληνική γλώσσα",id:23},//希腊语
          {"label":"Slovenščina",id:24},//希腊语
          {"label":"English",id:25},//英语2
          {"label":"Azərbaycan",id:26},//阿塞拜疆
          {"label":"Burmese",id:27},//缅甸
          {"label":"Türkiye",id:28},//土耳其
          {"label":"Монгол хэл",id:29},//蒙古语
        ]
          that.axios.get(that.$lujin+"/api/Default/CXTMultilingual?ShopID="+that.ShopID)
          .then(res=>{
            console.log(localStorage.getItem(this.$route.query.Shopid+'pickindex'))
            console.log(localStorage.getItem(this.$route.query.Shopid+'pickxb'))
            console.log(res.data.data[0])
            console.log(res)
            var json=res.data.data[0]
            var shuzu=[]
            for(var i=0;i<sz.length;i++){
              if(sz[i].id==json.WXLangOne && json.WXLangOne!=0)shuzu.push(sz[i]);
            }
            for(var i=0;i<sz.length;i++){
              if(sz[i].id==json.WXLangTwo && json.WXLangTwo!=0)shuzu.push(sz[i]);
            }
            for(var i=0;i<sz.length;i++){
              if(sz[i].id==json.WXLangThree && json.WXLangThree!=0)shuzu.push(sz[i]);
            }
            for(var i in shuzu){
              shuzu[i].index=parseInt(i)+1
            }
            console.log(shuzu)
            that.pickData=shuzu;
            if(json.WXLangOne==0&&json.WXLangTwo==0&&json.WXLangThree==0){
              that.pickData=sz;
            }
            that.WXLangGoods=json
            var s1=localStorage.getItem(this.$route.query.Shopid+'pickxb')!=null
            var s2=localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb')!=null
            var s3=localStorage.getItem(this.$route.query.Shopid+'pickindex')<shuzu.length
            console.log(s1,s2,s3)
            if(s1&&s2&&s3){
               console.log(localStorage.getItem(this.$route.query.Shopid+'pickxb'),shuzu.length,localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb'))
               that.pickxb=localStorage.getItem(this.$route.query.Shopid+'pickxb')
               that.WXLangGoodsxb=localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb')
               that.pickindex=localStorage.getItem(this.$route.query.Shopid+'pickindex')
            }else{
              that.pickxb=json.WXLangOne-1//语言下标
              that.WXLangGoodsxb=json.WXGoodsNameOne//菜品下标
              that.pickindex=0//文字下标
              localStorage.setItem(this.$route.query.Shopid+'pickxb',json.WXLangOne-1)
              localStorage.setItem(this.$route.query.Shopid+'pickindex',0)
            }
            console.log(that.pickxb,that.pickindex)
          })
          console.log(localStorage.getItem(this.$route.query.Shopid+'pickindex')==true,this.pickindex)

          var sj1=[],sj2=[],sj3=[]
          for(var i=0;i<24;i++){
            var list={"label":i}
            if(i<10)list.label="0"+i;
            sj1.push(list)
          }
          for(var i=0;i<60;i+=5){
            var list={"label":i}
            if(i<10)list.label="0"+i;
            sj2.push(list)
          }
          this.wfz=[sj1,sj2]
          console.log(1)
      },
      confirm3:function(res){
        console.log(res)
        this.PayFs=res[0]
      },
      bpqhans:function(i,j){
        console.log(this.kexuanlist[i].list[j])
        if(this.kexuanlist[i].list[j].Qua<0){
          this.kexuanlist[i].list[j].Qua=0
        }
        var sl=0
        for(var p in this.kexuanlist[i].list){
          sl+=parseInt(this.kexuanlist[i].list[p].Qua)?parseInt(this.kexuanlist[i].list[p].Qua):0
        }
        console.log(sl,this.kexuanlist[i].MaxSelItems)
        if(sl>this.kexuanlist[i].MaxSelItems){
          this.kexuanlist[i].list[j].Qua=0
          this.kexuanlist[i].list[j].zt=false
          var sll=0
          for(var p in this.kexuanlist[i].list){
            console.log(this.kexuanlist[i].list[p].Qua)
            sll+=parseInt(this.kexuanlist[i].list[p].Qua)?parseInt(this.kexuanlist[i].list[p].Qua):0
          }
          console.log(this.kexuanlist[i])
          console.log(sll)
          this.kexuanlist[i].sl=sll
        }else{
          console.log(this.kexuanlist[i].sl)
          console.log(sl)
          console.log(this.kexuanlist[i].list[j].Qua)
          console.log(this.kexuanlist[i].list[j].Qua=="")
          this.kexuanlist[i].sl=sl
          if(this.kexuanlist[i].list[j].Qua>0){
            this.kexuanlist[i].list[j].zt=true
          }
          if(this.kexuanlist[i].list[j].Qua==0||this.kexuanlist[i].list[j].Qua==""){
            this.kexuanlist[i].list[j].zt=false
          }
        }
        if(this.kexuanlist[i].list[j].Qua>0){
          var pgbl=0
          for(var o in this.Qlist){
            if(this.Qlist[o].ID==this.kexuanlist[i].list[j].ID){
              this.Qlist[o].Qua=this.kexuanlist[i].list[j].Qua
              pgbl=1
            }
          }
          if(pgbl==0){
            this.kexuanlist[i].list[j].Qua=parseInt(this.kexuanlist[i].list[j].Qua)
            this.Qlist.push(this.kexuanlist[i].list[j])
          }
        }

      },
      xiadanpq(){
        var that=this
        if(this.tableid=='Food'){
          if(this.foodzt==0){
            if(this.foods.name==''||this.foods.phone==''){
              this.toast(this.pickn[this.pickxb].qsr)
              return;
            }
          }
          if(this.foodzt==1){
            if(this.foods.name==''||this.foods.phone==''||this.foods.dizi==''){
              this.toast(this.pickn[this.pickxb].qsr)
              return;
            }
          }
          if(this.PayState=="1"&&this.PayFs.id=="0"){
            this.toast(this.pickn[this.pickxb].qsr)
            return;
          }
          if(this.PayState=="3"&&this.PayFs.id=="0"){
            this.toast(this.pickn[this.pickxb].qsr)
            return;
          }
        }
        if(that.gwcsl2>that.Numberpoints&&that.IsBuffet){
          that.toast(that.ztlist[that.pickxb].ooo)
          return
        }
        this.ConfirmLayer(this.picktan[this.pickxb].qdxd,function(flag){
          if(flag){
            if(that.PayState!="3"){
              that.xiadan()
            }else{
              that.jpzfzt=true
            }
          }
        })
      },
      wmtz(){
        window.location.href = "https://order.online/business/teabites-13107164"
      },
      fuzhi(){
        navigator.clipboard.writeText(this.zongji).then(() => {
        }).catch((err) => {
        });
      },
      //下单
      xiadan:throttle.throttle(function(){
        this.jpzfzt=false
        var _this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
        _this = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
        if(this.tableid=='Food'){
          if(this.foodzt==0){
            if(this.foods.name==''||this.foods.phone==''){
              this.toast(this.pickn[this.pickxb].qsr)
              return;
            }
          }
          if(this.foodzt==1){
            if(this.foods.name==''||this.foods.phone==''||this.foods.dizi==''){
              this.toast(this.pickn[this.pickxb].qsr)
              return;
            }
          }
        }
        var that=this
        console.log(that.gwclist,that.gwcsl,that.Numberpoints,that.gwcsl<that.Numberpoints)
        if(that.gwcsl2>that.Numberpoints&&that.IsBuffet){
          that.toast(that.ztlist[that.pickxb].ooo)
          return
        }
        /*if (navigator.geolocation) {
           var n = navigator.geolocation.getCurrentPosition(function(ssss){
               console.log(ssss); // 需要的坐标地址就在res中
           });
        } else {
            console.log(1231);
        }*/
        var data={
          bz:that.ggsq,
          zhuoid:that.tableid,
          ShopID:that.ShopID,
          list:that.gwclist,
          OrderMen:that.foods.name,
          OrderPhone:that.foods.phone,
          OrderAddress:that.foods.dizi,
          PostCode:that.foods.youb,
          OpTime:_this,
          CompleteTime: '1900-01-01 00:00:00',
          ToshopTime: '1900-01-01 00:00:00',
          ServerMoney:0,
          SheetState:0,
          PayState: 0,
          IsPay: 0,
          UserAgent:navigator.userAgent,
        }
        var sbdata=new Date();
        var sj=sbdata.getFullYear()+"-"+(sbdata.getMonth()+1)+"-"+sbdata.getDate()+" "+that.data_s+":"+that.data_f+":00"
        if(that.foodzt==0&&that.tableid=="Food"){
          data.SheetState=4
          data.ToshopTime= sj
        }//自提
        else if(that.foodzt==1&&that.tableid=="Food"){
          data.SheetState=3
          data.CompleteTime= sj
        }//外送
        else{data.SheetState=0}
        console.log(data)
        document.getElementById("loader-wrapper").style.display="block"
        document.getElementById("loader-wrapper").children[3].innerHTML=that.pickyan[that.pickxb].ddjd+"...";
        setTimeout(function(){
          document.getElementById("loader-wrapper").style.display="none"
        },20000)//10秒
        for(var ks in data.list){
          data.list[ks].IsBuffetGoods=data.list[ks].IsBuffetGoods?1:0
          data.list[ks].IsChild=data.list[ks].IsChild?true:false
          data.list[ks].isRoot=data.list[ks].isRoot?true:false
          data.list[ks].cm=0
          data.list[ks].unit=data.list[ks].unit?data.list[ks].unit:""
        }
        console.log(data)
        that.axios.post(that.$lujin+"/api/Default/Place_the_order",data)
        .then(res=>{
          console.log(res)
          var sheet=res.data.sheet
          if(res.data.state==true){
            var i=0;
            var time=setInterval(function(){
              that.axios.get(that.$lujin+"/api/Default/ddstate?SheetID="+sheet+"&ShopID="+that.ShopID+"&DeskID="+that.tableid)
              .then(res=>{
                console.log(res.data[0])
                if(res.data[0].State=='1'){
                  if(document.getElementById("loader-wrapper"))
                    document.getElementById("loader-wrapper").style.display="none"
                  localStorage.removeItem(that.ShopID+'list');
                  clearInterval(time);
                  if(that.tableid=="Food"){
                    that.$router.push("/dd?Shopid="+that.ShopID+"&id="+that.tableid+"&Phone="+that.foods.phone+"&PayState=1");
                  }else{
                    that.$router.push("/Qx?ShopID="+that.ShopID+"&DeskID="+that.tableid);
                  }
                }
                if(res.data[0].State=='2'){
                  clearInterval(time);
                  setTimeout(()=>{
                    that.axios.get(that.$lujin+"/api/Default/ddstate?SheetID="+sheet+"&ShopID="+that.ShopID+"&DeskID="+that.tableid)
                    .then(res=>{
                      console.log(res.data)
                      if(res.data[0].State=='1'){
                        if(document.getElementById("loader-wrapper"))
                          document.getElementById("loader-wrapper").style.display="none"
                        localStorage.removeItem(that.ShopID+'list');
                        that.$router.push("/Qx?ShopID="+that.ShopID+"&DeskID="+that.tableid);
                      }else if(res.data[0].State=='2'){
                        that.canzt=true
                        if(res.data[0].Failure=="1")that.cancen=that.ztlist[that.pickxb].o1
                        if(res.data[0].Failure=="4")that.cancen=that.ztlist[that.pickxb].o2
                        if(res.data[0].Failure=="3")that.cancen=that.ztlist[that.pickxb].o3
                        if(res.data[0].Failure=="11")that.cancen=that.ztlist[that.pickxb].o11
                        if(res.data[0].Failure=="12")that.cancen=that.ztlist[that.pickxb].O12
                        if(res.data[0].Failure=="13")that.cancen=that.ztlist[that.pickxb].O13+"("+(parseInt(res.data[0].Errorcontent))+"min)"
                        if(res.data[0].Failure=="14")that.cancen=that.ztlist[that.pickxb].o14
                        if(res.data[0].Failure=="15")that.cancen="估清"
                        clearInterval(time);
                        if(document.getElementById("loader-wrapper"))
                          document.getElementById("loader-wrapper").style.display="none"
                      }
                    })
                  },3000)
                }
              })
              //10秒
              if(i==11){
                console.log(1)
                that.axios.get(that.$lujin+"/api/Default/PosError?ShopID="+that.ShopID+"&DeskID="+that.tableid+"&Content=4")
                .then(res=>{
                  console.log(res)
                  that.canzt=true
                  that.cancen=that.ztlist[that.pickxb].o2
                  if(res.data.state=="1"){
                    clearInterval(time);
                    if(document.getElementById("loader-wrapper"))
                      document.getElementById("loader-wrapper").style.display="none"
                  }else{
                    clearInterval(time);
                  }
                })
              }
              i++;
            },1000);
          }else{
            if(document.getElementById("loader-wrapper"))
              document.getElementById("loader-wrapper").style.display="none"
          }
        })
      },2000),
      laclick(i){
        //console.log(this.xq_la)
        this.xq_la[i].ZT=!this.xq_la[i].ZT
        return
        if(!this.xq_la[i].ZT){
          var sum=0
          for(var z in this.xq_la){
            if(this.xq_la[z].ZT)
              sum++
          }
          if(sum<4)
            this.xq_la[i].ZT=!this.xq_la[i].ZT;
        }
        else{
          this.xq_la[i].ZT=!this.xq_la[i].ZT;
        }

        var sql=JSON.parse(localStorage.getItem(this.ShopID+'list'))
        var zf="",js=0
        var GoodsID=this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID//编号
        var IsUnitPrice=this.pq[this.xqxb_i].sz[this.xqxb_j].IsUnitPrice//有没有单位
        var DisRemark=this.pq[this.xqxb_i].sz[this.xqxb_j].DisRemark//有没有做法
        var MessyPrice=this.xq_list[this.ggxb].MessyPrice//选中单位的价格
        var Momey=this.pq[this.xqxb_i].sz[this.xqxb_j].MessyPrice//菜品价格
        for(var p in this.xq_la){
          if(this.xq_la[p].ZT){
            if(zf!="")zf+=",";js++;zf+=this.xq_la[p].RemarkID//obj.momey+=this.xq_la[i].AddPrice//做法附加价
          }
        }
        if(js<8){
          for(var p=js;p<8;p++){
            if(p==0){
              zf="0,0,0,0,0,0,0,0";break;
            }zf+=",0"
          }
        }//做法查询ID
        this.gmsl=0
        console.log(sql,zf,GoodsID,IsUnitPrice,DisRemark)
        for(var w in sql){
          if(sql[w].zf==zf&&sql[w].id==GoodsID&&!IsUnitPrice&&DisRemark){
            this.gmsl=sql[w].sl
          }else if(sql[w].zf==zf&&sql[w].id==GoodsID&&IsUnitPrice&&DisRemark&&MessyPrice+Momey==sql[w].momey){
            this.gmsl=sql[w].sl
          }
        }
      },
      laclick2(i,j){
        console.log(this.xq_la2)
        console.log(i,j)
        this.xq_la2[i].TRemarkGroupItemsTemp[j].ZT=!this.xq_la2[i].TRemarkGroupItemsTemp[j].ZT
      },
      /*备注*/
      bzclick(index){
        this.lsxb=index
        var that=this
        this.ConfirmLayer2(this.pickn[this.pickxb].qsrbz,function(res){
          if(res)
          that.gwclist[that.lsxb].bz=document.getElementById('confirminput').value;
          document.getElementById('confirminput').style.display="none";
        },this.gwclist[index].bz)
      },
      /*弹窗控件*/
      ConfirmLayer: function(txt, callback,nb) {
        var _this = this;
        var confirmLayercovering = document.getElementById('confirmLayercovering'),
        confirmTit = document.getElementById('confirmTit'),
        confirmClose = document.getElementById('confirmClose'),
        confirminput = document.getElementById('confirminput'),
        confirmSure = document.getElementById('confirmSure'),
        confirmCall = callback,
        tittxt = txt;
        confirminput.style.display='none'
        if(nb){
          confirmClose.style.display="none"
        }
        if (!confirmLayercovering) {
          return;
        }
        var init = function() {
            if (txt) {
              confirmTit.innerHTML = txt;
            }
            show();
            confirmClose.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(false);
            });
            confirmSure.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(true);
            });
          },
          hide = function() {
            confirmLayercovering.style.display = 'none';
          },
          show = function() {
            confirmLayercovering.style.display = 'block';
          },
          Confirm = function(txt, callback) {
            if (tittxt != txt && txt) {
              confirmTit.innerHTML = txt;
              tittxt = txt;
            }
            confirmCall = callback;
            show();
          };
        init(); //初始化
        _this.ConfirmLayer = Confirm; //下次不用再初始化
      },
      /*备注*/
      ConfirmLayer2: function(txt, callback,tr) {
        var _this = this;
        var confirmLayercovering = document.getElementById('confirmLayercovering'),
          confirmTit = document.getElementById('confirmTit'),
          confirmClose = document.getElementById('confirmClose'),
          confirminput = document.getElementById('confirminput'),
          confirmSure = document.getElementById('confirmSure'),
          confirmCall = callback,
          tittxt = txt;
        confirminput.style.display='none'
        //console.log(tr)
          confirminput.style.display='block'
          confirminput.value=tr
        if (!confirmLayercovering) {
          return;
        }
        var init = function() {
            if (txt) {
              confirmTit.innerHTML = txt;
            }
            show();
            confirmClose.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(false);
            });
            confirmSure.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(true);
            });
          },
          hide = function() {
            confirmLayercovering.style.display = 'none';
          },
          show = function() {
            confirmLayercovering.style.display = 'block';
          },
          Confirm = function(txt, callback) {
            if (tittxt != txt && txt) {
              confirmTit.innerHTML = txt;
              tittxt = txt;
            }
            confirmCall = callback;
            show();
          };
        init(); //初始化
        _this.ConfirmLayer = Confirm; //下次不用再初始化
      },
      ConfirmLayer3: function(txt, callback,nb) {
        //console.log(txt)
        var _this = this;
        var confirmLayercovering = document.getElementById('confirmLayercovering'),
        confirmTit = document.getElementById('confirmTit'),
        confirmClose = document.getElementById('confirmClose'),
        confirminput = document.getElementById('confirminput'),
        confirmSure = document.getElementById('confirmSure'),
        confirmCall = callback,
        tittxt = txt;
        confirminput.style.display='none'
        if(nb){
          confirmClose.style.display="none"
        }
        if (!confirmLayercovering) {
          return;
        }
        var init = function() {
            if (txt) {
              confirmTit.innerHTML = txt;
            }
            show();
            confirmClose.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(false);
            });
            confirmSure.addEventListener('click', function() {
              hide();
              confirmCall && confirmCall(true);
            });
          },
          hide = function() {
            confirmLayercovering.style.display = 'none';
          },
          show = function() {
            confirmLayercovering.style.display = 'block';
          },
          Confirm = function(txt, callback) {
            if (tittxt != txt && txt) {
              confirmTit.innerHTML = txt;
              tittxt = txt;
            }
            confirmCall = callback;
            show();
          };
        init(); //初始化
        _this.ConfirmLayer = Confirm; //下次不用再初始化
      },
      /*购物车删除*/
      delclick() {
        var that=this
        this.ConfirmLayer(this.picktan[this.pickxb].sfsc, function(flag) {
          if (flag) {
            for(var i=that.gwclist.length-1;i>=0;i--){
              if(that.gwclist[i].zt){
                that.gwclist.splice(i,1)
              }
            }
            that.sfqx()
            that.zongjia()
            localStorage.setItem(that.ShopID+'list',JSON.stringify(that.gwclist))
          }
        })
      },
      /*购物车全选*/
      qxclick(re){
        if(!re){
          for(var i in this.gwclist){
            this.gwclist[i].zt=true
          }
        }else{
          for(var i in this.gwclist){
            this.gwclist[i].zt=false
          }
        }
        this.sfqx()
        this.zongjia()
      },
      /*提示窗*/
      toast(str) {
      						let v = this
      						v.toastText = str
      						v.toastShow = true
      						setTimeout(function() {
      							v.toastShow = false
      						}, 2500)
      },
      /*加入购物车*/

      /*回到商品页*/
      xqesc(){
        /*document.getElementById("loader-wrapper").style.display="block"
        setTimeout(function(){
          document.getElementById("loader-wrapper").style.display="none"
        },100)
        location.reload();
        return;*/
        //this.danji();
        var that=this
        this.pand=!this.pand
        this.$nextTick(() => {
          $('body,html').animate({
             scrollTop:that.scrollTop
          }, 0);
          //document.documentElement.scrollTop=list[e].offsetTop-document.getElementById("yuyan").offsetHeight;
        });
        this.danji(false);
        //this.navMenuType = 'float:left;position: absolute;'
      },
      /*回到商品页更新购物车*/
      escclick(){
        localStorage.setItem(this.ShopID+'list',JSON.stringify(this.gwclist))
        var sum=0
        //console.log(this.gwclist)
        for(var i in this.gwclist){
          sum+=this.gwclist[i].sl
        }
        this.gwcsl=sum
        this.cur=!this.cur
        /*document.getElementById("loader-wrapper").style.display="block"
        setTimeout(function(){
          document.getElementById("loader-wrapper").style.display="none"
        },00)*/
        this.jiazai(false)
        this.pdcd=true;
        this.yyds();
        //this.$router.go(0)
      },
      /*回到商品页*/
      djclick(e){
        //console.log(this.gwclist,e)
        this.gwclist[e].zt=!this.gwclist[e].zt
        this.sfqx()
        this.zongjia()
      },
      /*加减购物车*/
      gwcjian(e){
        console.log(this.gwclist)
        if(this.gwclist[e].sl>1){
          if(this.gwclist[e].MinShare!=0&&this.gwclist[e].sl==this.gwclist[e].MinShare){
            this.gwclist.splice(e,1)
          }else{
            this.gwclist[e].sl--;
          }
          if(this.gwclist[e].isRoot==1){
            for(var b in this.gwclist){
              console.log(this.gwclist[b].FromID,this.gwclist[e].FromID,this.gwclist[e].isRoot)
              if(this.gwclist[b].FromID==this.gwclist[e].FromID&&this.gwclist[b].isRoot==0){
                this.gwclist[b].sl-=(this.gwclist[b].jcQua?this.gwclist[b].jcQua:1)
              }
            }
          }
        }else if(this.gwclist[e].sl==1&&this.gwclist[e].isRoot==1){
            var gwclist=[],FromID=this.gwclist[e].FromID
            for(var b in this.gwclist){
              if(this.gwclist[b].FromID!=FromID){
                gwclist.push(this.gwclist[b])
              }
            }
            this.gwclist=gwclist
        }else if(this.gwclist[e].sl==1&&this.gwclist[e].isRoot==0){
            this.gwclist.splice(e,1)
        }
        localStorage.setItem(this.ShopID+"list",JSON.stringify(this.gwclist))
        this.zongjia()
      },
      gwcjia(e){
        if(this.gwclist[e].MaxQuas){
          if(this.gwclist[e].MaxQuas>0)return
        }
        var bbq=0
        for(var i in this.gwclist){
          if(this.gwclist[i].IsBuffetGoods)
            bbq+=this.gwclist[i].sl
        }
        //console.log(bbq,this.IsBuffet)
        if(bbq>=this.Numberpoints&&this.IsBuffet&&this.gwclist[e].IsBuffetGoods){
          this.toast(this.ztlist[this.pickxb].ooo)
          return
        }
        console.log(this.gwclist)
        if(this.gwclist[e].sl<99){
          if(this.gwclist[e].isRoot==1){
              for(var b in this.gwclist){
                if(this.gwclist[b].FromID==this.gwclist[e].FromID){
                  this.gwclist[b].sl+=(this.gwclist[b].jcQua?this.gwclist[b].jcQua:1);
                }
              }
          }else{
            this.gwclist[e].sl++;
          }
        }
        localStorage.setItem(this.ShopID+"list",JSON.stringify(this.gwclist))
        this.zongjia()
      },
      /*打开购物车*/
      curclick(){
        var date=new Date()
        this.data_s=date.getHours()<10?"0"+date.getHours():date.getHours()
        this.data_f=date.getMinutes()<10?"0"+date.getMinutes():date.getMinutes()
        document.getElementById("loader-wrapper").style.display="block"
        setTimeout(function(){
          document.getElementById("loader-wrapper").style.display="none"
        },200)
        document.documentElement.scrollTop=0;
        this.cur=true;
        if(localStorage.getItem(this.ShopID+'list')==null||localStorage.getItem(this.ShopID+'list')==""){
          this.gwclist==[]
        }else{
          this.gwclist=JSON.parse(localStorage.getItem(this.ShopID+'list'))
		  console.log(this.gwclist)
          /*var gwclist=JSON.parse(localStorage.getItem(this.ShopID+'list'))
          for(var i in gwclist){
            if(gwclist[i].IsChild==0){
              this.gwclist.push(gwclist[i])
            }
          }*/
        }
        this.zongjia()
        this.sfqx()
      },
      /*计算总价*/
      zongjia(){
        var sum=0
        var ojb=JSON.parse(localStorage.getItem(this.ShopID+'list'))
        //console.log(ojb)
        for(var i in ojb){
          sum+=(ojb[i].momey+(ojb[i].addmomey?ojb[i].addmomey:0))*ojb[i].sl
        }
        this.zongji=sum
      },
      /*判断是否全选*/
      sfqx(){
        for(var i in this.gwclist){
          if(!this.gwclist[i].zt){
          this.quanxuan=false;
          return;
          }
        }
        this.quanxuan=true;
      },
      /*获取菜品分类*/
      danji(state){
        console.log(this.ShopID)
        var that=this
        var json=that.Menulist
		if(state){
			var sb=json[json.length-1]
			json.push(sb)
			console.log(sb)
			this.feilist=json
		}
        this.feilist_two=json
        /*查询菜品列表 处理数据*/
        var json2=that.Goodslist
        var pq=[]
        console.log(json2)
        if(that.IsBuffet){
          var jsonsz=[]
          for(var j in json2){
            if(json2[j]!=null){
              var busz=json2[j].BuffetTypeID.split(',')
              var busz2=json2[j].DisplayBuffet.split(',')
              var add=json2[j].BuffetAddMoney.split(',')
              var OutPrice=json2[j].OutPrice.split(',')
              var MaxQua=json2[j].MaxQua.split(',')
              for(var ppp in busz){
              	if(busz[ppp]==that.BuffetTypeID){
                  json2[j].IsBuffetGoods=1
                  json2[j].Price=parseFloat(add[ppp].substr(add[ppp].lastIndexOf(":") + 1))
              	}
              }
              for(var ppp in OutPrice){
              	var szlists=OutPrice[ppp].split(':')
              	if(szlists[0]==that.BuffetTypeID){
              		json2[j].OutPrices=parseFloat(szlists[1])
              	}
              }
              for(var ppp in MaxQua){
              	var szlists=MaxQua[ppp].split(':')
              	if(szlists[0]==that.BuffetTypeID){
              		json2[j].MaxQuas=parseInt(szlists[1])
              	}
              }
              for(var ppp in busz2){
              	if(busz2[ppp]==that.BuffetTypeID){
                  jsonsz.push(json2[j])
              	}
              }
            }
          }
          json2=jsonsz
          for(var i in json){
            pq.push(
				{
					name1:json[i].TypeName,
					name2:json[i].TwoTypeName,
					name3:json[i].ThreeTypeName,
					name3:json[i].ThreeTypeName,
					MadeDepotID:json[i].MadeDepotID,
					sz:[],
				})
            for(var j in json2){
              if(json[i].TypeID==json2[j].TypeID){
                json2[j].sl=0
                json2[j].src=this.$lujin+'/Data/'+this.ShopID+'/GoodsPic/'+json2[j].GoodsID+'.jpg'
                pq[i].sz.push(json2[j])
              }
            }
          }
          if(localStorage.getItem(this.ShopID+'list')){
          var bpq=localStorage.getItem(this.ShopID+'list')
          var pqon=[]
          if(bpq==null||bpq==""){
            pqon=[]
          }else{
            pqon=JSON.parse(localStorage.getItem(this.ShopID+'list'))
          }
          //console.log(pq,pqon)
          for(var i=0;i<pq.length;i++){
            for(var j=0;j<pq[i].sz.length;j++){
              for(var k in pqon){
                if(pq[i].sz[j].GoodsID==pqon[k].id)
                  pq[i].sz[j].sl+=pqon[k].sl
              }
            }
          }
          }
          console.log(pq)
          /*for(var i in pq){
            if(pq[i].sz.length==0){
              pq.splice(i,1)
              that.feilist.splice(i,1)
            }
          }*/
          if(state){
          	this.pq=pq
          }
          this.pq_two=pq
        }
        else{
          console.log(json,json2)
          var ressz=[]
          for(let p in json2){
          	if(json2[p].IsBuffetDeskShow){
          	}else{
          		ressz.push(json2[p])
          	}
          }
          json2=ressz
          for(var i in json){
            pq.push(
            	{
            		name1:json[i].TypeName,
            		name2:json[i].TwoTypeName,
            		name3:json[i].ThreeTypeName,
            		name3:json[i].ThreeTypeName,
            		MadeDepotID:json[i].MadeDepotID,
            		sz:[],
            	})
            for(var j in json2){
              if(json2[j]!=null){
                if(json[i].TypeID==json2[j].TypeID){
                  json2[j].sl=0
                  json2[j].src=this.$lujin+'/Data/'+this.ShopID+'/GoodsPic/'+json2[j].GoodsID+'.jpg'
                  pq[i].sz.push(json2[j])
                }
              }
            }
          }
          if(localStorage.getItem(this.ShopID+'list')){
          var bpq=localStorage.getItem(this.ShopID+'list')
          var pqon=[]
          if(bpq==null||bpq==""){
            pqon=[]
          }else{
            pqon=JSON.parse(localStorage.getItem(this.ShopID+'list'))
          }
          console.log(pq,pqon)
          for(let i=0;i<pq.length-1;i++){
            for(let j=0;j<pq[i].sz.length;j++){
              for(let k in pqon){
                if(pq[i].sz[j].GoodsID==pqon[k].id){
                  console.log(i,j,pq[i].sz[j].GoodsID)
                  pq[i].sz[j].sl+=pqon[k].sl
                }
              }
            }
          }
        }
          console.log(pq)
		  console.log(state)
		  if(state){
		  	this.pq=pq
		  }
          this.pq_two=pq
        }
      },
      /*添加小数*/
      toFix(num1){
          //console.log(typeof(num1))
          if(typeof(num1)=='undefined'){
              return num1
          }else{
              return Number(num1.toFixed(2))
          }
      },
      /*切换选项卡*/
      goodsAdd(){
            if(this.goodsNum == 0){
              if(!this.show){
                this.show = true
                this.id = setInterval(()=>{
                  this.num -= 18
                  this.subStyle.transform = `rotate(${this.num}deg)`
                  this.rightNum += 5
                  this.subStyle.right = `${this.rightNum}px`
                  this.subStyle.opacity += 0.1
                  if(this.num <= -180){
                    clearInterval(this.id)
                    this.id = null
                  }
                },50)
              }
            }

            this.goodsNum ++

          },
          goodsSub(){
            this.goodsNum --
            if(this.goodsNum == 0){
              this.id = setInterval(()=>{
                this.num += 18
                this.subStyle.transform = `rotate(${this.num}deg)`
                this.rightNum -= 5
                this.subStyle.right = `${this.rightNum}px`
                this.subStyle.opacity -= 0.1
                if(this.num >= 0){
                  clearInterval(this.id)
                  this.id = null
                  this.show = false
                }
              },50)
            }

            //触发事件
            this.$emit('subcarts')
          },
          addGoods(e,is,i,j,pd,nb) {
            if(this.pq[i].sz[j].IsSetMeal&&pd==false){
              var sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
              console.log(1231)
              for(var os in sz){
                if(sz[os].isRoot==1&&sz[os].id==this.pq[i].sz[j].GoodsID){
                  for(var ob in sz){
                    if(sz[ob].FromID==sz[os].FromID){
                      console.log(123)
                      sz[ob].sl=0
                    }
                  }
                }
              }
              var bpq=[]
              for(var sb in sz){
                if(sz[sb].sl>0){
                  bpq.push(sz[sb]);
                }
              }
              localStorage.setItem(this.ShopID+'list', JSON.stringify(bpq));
              this.gwclist=bpq
              this.pq[i].sz[j].sl--
              var sbsl=0
              for(var qqw in bpq){
                sbsl+=bpq[qqw].sl
              }
              this.gwcsl=sbsl
              return
            }
			
			console.log(this.buffsz)
			console.log(this.pq[i].sz[j].IsBuffetGoods&&this.buffsz.length>0)
			if(this.pq[i].sz[j].IsBuffetGoods&&this.buffsz.length>0&&pd&&!this.pq[i].sz[j].DisRemark){
				for(var ia in this.buffsz){
					for(var ja in this.buffsz[ia].Items){
						if(this.buffsz[ia].Items[ja].GoodsID==this.pq[i].sz[j].GoodsID){
							if(this.buffsz[ia].BuffetChooseType==1){
								if(this.buffsz[ia].Qua>=(this.buffsz[ia].MaxQua*this.MenuQua)){
									this.toast(this.picktan[this.pickxb].zfkx)
									return
								}
								if(this.buffsz[ia].Qua<(this.buffsz[ia].MaxQua*this.MenuQua)){
									this.buffsz[ia].Qua++
								}
							}
						}
					}
				}
			}
			if(this.pq[i].sz[j].IsBuffetGoods&&this.buffsz.length>0&&!pd){
				for(var ia in this.buffsz){
					for(var ja in this.buffsz[ia].Items){
						if(this.buffsz[ia].Items[ja].GoodsID==this.pq[i].sz[j].GoodsID){
							if(this.buffsz[ia].BuffetChooseType==1){
								if(this.buffsz[ia].Qua>0){
									this.buffsz[ia].Qua--
								}
							}
						}
					}
				}
			}
			
            var bbq=0
            console.log(is,pd,nb)
            var bpq=localStorage.getItem(this.ShopID+'list')
            var sz=[]
            if(bpq==null||bpq==""){
              sz=[]
            }else{
              sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
            }
            for(var ccc in sz){
              if(sz[ccc].IsBuffetGoods)
                bbq+=sz[ccc].sl
            }
            console.log(this.IsBuffet,bbq,this.Numberpoints)
            if(bbq>=this.Numberpoints&&pd&&this.IsBuffet&&this.pq[i].sz[j].IsBuffetGoods){
              this.toast(this.ztlist[this.pickxb].ooo)
              return
            }
            if(pd){
              if((is&&!this.IsBuffet) || nb){
                this.xqclick(i,j,is,nb)
                return;
              }
              if((this.pq[i].sz[j].IsSetMeal&&!this.IsBuffet)){
                this.xqclick(i,j,is,nb)
                return;
              }
              if(this.pq[i].sz[j].sl<99){
                if(this.pq[i].sz[j].sl==0&&this.pq[i].sz[j].MinShare!=0){
                  this.pq[i].sz[j].sl=this.pq[i].sz[j].MinShare
                }else{
                  this.pq[i].sz[j].sl++
                }
              }else{
                return;
              }
            }else{
              if((is&&!this.IsBuffet) || nb){
                this.xqclick(i,j,is,nb)
                return;
              }
              if(this.pq[i].sz[j].sl==this.pq[i].sz[j].MinShare){
                this.pq[i].sz[j].sl=0
              }else{
                this.pq[i].sz[j].sl--
                var list=JSON.parse(localStorage.getItem(this.ShopID+'list'))
                list=list.reverse()
                for (let sb in list) {
                	if (list[sb].id == this.pq[i].sz[j].GoodsID) {
                		list[sb].sl--;
                		if (list[sb].sl == 0) {
                			list.splice(sb, 1);
                		}
                    list=list.reverse()
                    localStorage.setItem(this.ShopID+'list', JSON.stringify(list));
                    var sum=0
                    var bbq=0
                    for(var i in list){
                      sum+=list[i].sl
                      if(list[i].IsBuffetGoods){
                        bbq+=list[i].sl
                      }
                    }
                    this.gwcsl=sum
                    this.gwcsl2=bbq
                		return;
                	}
                }
              }
            }
            if(pd&&this.pq[i].sz[j].IsBuffetGoods&&this.IsBuffet&&this.pq[i].sz[j].MaxQuas>0){
              console.log("是哪里是")
              if(this.pq[i].sz[j].sl-1>=this.MenuQua*this.pq[i].sz[j].MaxQuas){
                var sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
                var obj={
                  zt:true,
                  xb_i:i,
                  xb_j:j,
                  sl:1,
                  bz:'',
                  id:this.pq[i].sz[j].GoodsID,
                  momey:this.pq[i].sz[j].Price+this.pq[i].sz[j].OutPrices,
                  Goods:this.pq[i].sz[j].Goods,
                  TwoGoods:this.pq[i].sz[j].TwoGoods,
                  ThreeGoods:this.pq[i].sz[j].ThreeGoods,
                  IsBuffetGoods:this.pq[i].sz[j].IsBuffetGoods,
                  addmomey:0,
                  FromID:0,
                  IsChild:0,
                  isRoot:0,
                  zf:"0,0,0,0,0,0,0,0",
                  zuofa1:"",
                  zuofa2:"",
                  zuofa3:"",
                  MinShare:this.pq[i].sz[j].MinShare,
                  getTime:(new Date()).getTime(),
                  MaxQuas:this.pq[i].sz[j].MaxQuas
                }
                console.log(obj)
                sz.push(obj)
                localStorage.setItem(this.ShopID+'list', JSON.stringify(sz));
                this.gwclist=sz
                var sum=0
                var bbq=0
                for(var i in sz){
                  sum+=sz[i].sl
                  if(sz[i].IsBuffetGoods){
                    bbq+=sz[i].sl
                  }
                }
                this.gwcsl=sum
                this.gwcsl2=bbq
                let el = e.target;
                this.balls.forEach(v => {
                  if (!v.show) {
                    v.show = true; // 当切换元素的display:block/none时，会触发vue的动画
                    v.el = el; // 将触发点击事件的“+”号保定道小球对象上，方便获取动画初始时的位置
                    this.dropBalls.push(v); // 取一个小球加入动画队列
                    return;
                  }
                });
                this.goodsAdd()
                this.$emit('oncarts')
                return
              }
            }

            /*处理购物车*/
            var sz=[]
            var obj={
              zt:true,
              xb_i:i,
              xb_j:j,
              sl:this.pq[i].sz[j].sl,
              bz:'',
              id:this.pq[i].sz[j].GoodsID,
              momey:this.pq[i].sz[j].MessyPrice,
              Goods:this.pq[i].sz[j].Goods,
              TwoGoods:this.pq[i].sz[j].TwoGoods,
              ThreeGoods:this.pq[i].sz[j].ThreeGoods,
              IsBuffetGoods:this.pq[i].sz[j].IsBuffetGoods,
              addmomey:0,
              FromID:0,
              IsChild:0,
              isRoot:0,
              zf:"0,0,0,0,0,0,0,0",
              zuofa1:"",
              zuofa2:"",
              zuofa3:"",
              MinShare:this.pq[i].sz[j].MinShare,
              getTime:(new Date()).getTime(),
              MaxQuas:this.pq[i].sz[j].MaxQuas?this.pq[i].sz[j].MaxQuas:0
            }
            console.log(obj)
            if(this.pq[i].sz[j].IsBuffetGoods&&this.IsBuffet){
                obj.momey=this.pq[i].sz[j].Price
            }

            if(localStorage.getItem(this.ShopID+'list')){
              sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
              for(var k in sz){
                if(sz[k].xb_i==i && sz[k].xb_j==j&&sz[k].id==this.pq[i].sz[j].GoodsID){
                  sz[k]=obj;
                  obj=false;
                  break;
                }
              }
            }
            if(obj){
              sz.push(obj)
            }
            for(var i in sz){
              if(sz[i].sl==0){
                sz.splice(i,1);
              }
            }
            localStorage.setItem(this.ShopID+'list', JSON.stringify(sz));
            this.gwclist=sz
            var sum=0
            var bbq=0
            for(var i in sz){
              sum+=sz[i].sl
              if(sz[i].IsBuffetGoods)
                bbq+=sz[i].sl
            }
            this.gwcsl=sum
            this.gwcsl2=bbq
            /*（´Д`)*/
            if(!pd)return;
            let el = e.target;
            this.balls.forEach(v => {
              if (!v.show) {
                v.show = true; // 当切换元素的display:block/none时，会触发vue的动画
                v.el = el; // 将触发点击事件的“+”号保定道小球对象上，方便获取动画初始时的位置
                this.dropBalls.push(v); // 取一个小球加入动画队列
                return;
              }
            });
            this.goodsAdd()
            this.$emit('oncarts')
          },
          beforeEnter(el) {

            let count = this.balls.length;
            while (count--) {
              // 将动画队列中的小球，依次处理
              let ball = this.balls[count];
              if (ball.show) {
                let rect = ball.el.getBoundingClientRect(); //拿到点击的“+”号的位置,这里不直接取值（我是用的绝对定位，当然可以直接取值）的原因是，商品列表中每个加号的位置是不固定的，如果上下滑动了，这个位置就不确定
                let x = rect.left - 70; // 需要偏移的x向距离
                let y = -(window.innerHeight - rect.top - 65); // 需要偏移的y向距离
                el.style.display = ""; // 当前状态下，display值为none，将其置空。

                // 这里需要注意了，小球飞入的动画分两个维度，X轴和Y轴，因此
                el.style.webkitTransform = `translate3d(0px, ${y}px, 0px)`; // 首先将“ball”Y向移动至“+”好位置
                el.style.transform = `translate3d(0px, ${y}px, 0px)`;
                // 接着将“inner-hook”X向移动至“+”号处，其实此时外层“ball”的X位置没有动，但因为背景色等等样式只应用于“inner-hook”上，因此，视觉效果上，这个小球是移动到了“+”号的位置
                let inner = el.getElementsByClassName("inner-hook")[0];
                inner.style.webkitTransform = `translate3d(${x}px, 0, 0)`;
                inner.style.transform = `translate3d(${x}px, 0, 0)`;
              }
            }
          },
          enter(el) {
            /* eslint-disable no-unused-vars */

            let rf = el.offsetHeight; // 主动触发浏览器重绘
            this.$nextTick(() => {
              el.style.webkitTransform = "translate3d(0, 0, 0)"; //接着将小球位置置为初始值，但css中设置了transition .8s,因此，动画效果就出来了
              el.style.transform = "translate3d(0, 0, 0)";
              let inner = el.getElementsByClassName("inner-hook")[0];
              inner.style.webkitTransform = "translate3d(0, 0, 0)";
              el.style.transform = "translate3d(0, 0, 0)";
            });
          },
          afterEnter(el) {

            let ball = this.dropBalls.shift(); //结束后，将这个活动中的小球删除
            if (ball) {
              ball.show = false;
              el.style.display = "none"; // 并且将其设为不可见
            }
        },
      feiclick: function(e,on) {
        this.fei_xb = e
        var that=this
        if(on){
			return;
		}
        var list=this.$refs.piediv.children
		console.log(list)
        console.log(list[e].offsetTop)
        this.$nextTick(() => {
          $('body,html').animate({
             scrollTop : list[e].offsetTop
          }, 0);
          //document.documentElement.scrollTop=list[e].offsetTop-document.getElementById("yuyan").offsetHeight;
        });
        setTimeout(function(){
          that.fei_xb = e
        },50)
      },
      /*动画*/
      addShopCart (i) {
                  this.rotate=!this.rotate;
                  //console.log(this.rotate)
      },
      jianclick(){
        if(this.gmsl==this.pq[this.xqxb_i].sz[this.xqxb_j].MinShare){
          return
        }
        var sql=JSON.parse(localStorage.getItem(this.ShopID+'list'))
        console.log(sql)
        var zf="",js=0
        for(var p in this.xq_la){
          if(this.xq_la[p].ZT){
            if(zf!="")zf+=",";js++;zf+=this.xq_la[p].RemarkID//obj.momey+=this.xq_la[i].AddPrice//做法附加价
          }
        }
        if(js<8){
          for(var p=js;p<8;p++){
            if(p==0){
              zf="0,0,0,0,0,0,0,0";break;
            }zf+=",0"
          }
        }//做法查询ID
        if(this.gmsl>0){
          this.gmsl--;
          var GoodsID=this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID//编号
          var IsUnitPrice=this.pq[this.xqxb_i].sz[this.xqxb_j].IsUnitPrice//有没有单位
          var DisRemark=this.pq[this.xqxb_i].sz[this.xqxb_j].DisRemark//有没有做法
          var MessyPrice=this.xq_list[this.ggxb].MessyPrice//选中单位的价格
          var Momey=this.pq[this.xqxb_i].sz[this.xqxb_j].MessyPrice//菜品价格
          console.log(IsUnitPrice,DisRemark)
          for(var k in sql){
            if(GoodsID==sql[k].id&&!IsUnitPrice&&!DisRemark){
              sql[k].sl=this.gmsl
              if(this.gmsl==0)
                sql.splice(k,1);
            }else if(GoodsID==sql[k].id&&zf==sql[k].zf&&!IsUnitPrice&&DisRemark){
              sql[k].sl=this.gmsl
              if(this.gmsl==0)
                sql.splice(k,1);
            }else if(GoodsID==sql[k].id&&MessyPrice+Momey==sql[k].momey&&IsUnitPrice&&!DisRemark){
              sql[k].sl=this.gmsl
              if(this.gmsl==0)
                sql.splice(k,1);
            }else if(GoodsID==sql[k].id&&MessyPrice+Momey==sql[k].momey&&IsUnitPrice&&DisRemark&&zf==sql[k].zf){
              sql[k].sl=this.gmsl
              if(this.gmsl==0)
                sql.splice(k,1);
            }
          }
          var ppppp=0
          for(var i in sql){
            ppppp+=sql[i].sl
          }
          this.gwcsl=ppppp
        }
        localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
      },
      xqclick(i,j,is,nb){
        this.xq_list=[{MessyPrice:0,Unit:''}]
        this.ggxb=0
        if(this.pq[i].sz[j].IsEmpty){
          return
        }
        if(this.pq[i].sz[j].MaxQuas>0){
          return
        }
		/*if(this.pq[i].sz[j].IsBuffetGoods&&this.buffsz.length>0){
		  return
		}*/
        //qweqwe
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(scrollTop)
        this.scrollTop=scrollTop
        document.getElementById("loader-wrapper").style.display="block"
        if(this.pq[i].sz[j].IsSetMeal||nb){

        }else{
          setTimeout(function(){
            document.getElementById("loader-wrapper").style.display="none"
          },800)
        }
        this.xqxb_i=i
        this.xqxb_j=j
        console.log(this.pq[i].sz[j])
        var zfxb=[],fff,danjg
        this.gmsl=this.pq[i].sz[j].MinShare==0?1:this.pq[i].sz[j].MinShare
        if(localStorage.getItem(this.ShopID+'list')){
          var sql=JSON.parse(localStorage.getItem(this.ShopID+'list'))
          var sum=0
          for(var k in sql){
            if(this.pq[i].sz[j].GoodsID==sql[k].id){
              fff=sql[k].zf.split(",");
              if(this.pq[i].sz[j].IsUnitPrice&&!this.pq[i].sz[j].DisRemark){
                danjg=sql[k].momey-this.pq[i].sz[j].MessyPrice
                this.gmsl=sql[k].sl
              }else if(!this.pq[i].sz[j].IsUnitPrice&&!this.pq[i].sz[j].DisRemark){
                this.gmsl=sql[k].sl
              }else if(!this.pq[i].sz[j].IsUnitPrice&&this.pq[i].sz[j].DisRemark){
                this.gmsl=sql[k].sl
              }else if(this.pq[i].sz[j].IsUnitPrice&&this.pq[i].sz[j].DisRemark){
                danjg=sql[k].momey-this.pq[i].sz[j].MessyPrice
                this.gmsl=sql[k].sl
              }
            }
          }
        }
        if(this.pq[i].sz[j].IsSetMeal){
          this.Qlist=[]
          if (this.pq[i].sz[j].IsFixup) { //固定套餐
          	this.axios.get(this.$lujin+"/api/Default/Guding?GoodsID="+this.pq[i].sz[j].GoodsID+"&ShopID="+this.ShopID).then(res=>{
              console.log(res)
              console.log(res.data.data)
              document.getElementById("loader-wrapper").style.display="none"
              var bbqq=res.data.data
              for (var i in bbqq) {
              	bbqq[i].pd = true
              	this.Qlist.push(bbqq[i])
              }
              this.gdlist = bbqq
              console.log(this.Qlist)
            })
          } else {//可选套餐
          	this.axios.get(this.$lujin+"/api/Default/Kexuan?GoodsID="+this.pq[i].sz[j].GoodsID+"&ShopID="+this.ShopID).then(res=>{
          	  console.log(res)
              document.getElementById("loader-wrapper").style.display="none"
              var bbqq=res.data.data
              for (var i in bbqq) {
                if(bbqq[i].IsFixup=="1"){
                  for(var j in bbqq[i].list){
                    //bbqq[i].list[j].Qua=1
                    bbqq[i].list[j].pd = true
                    this.Qlist.push(bbqq[i].list[j])
                  }
                }
                for (var j in bbqq[i].list) {
                	bbqq[i].list[j].Jine=bbqq[i].list[j].Price
                	bbqq[i].list[j].Zuofa=""
                  if (bbqq[i].IsFixup=="1"){
                    bbqq[i].list[j].zt = true
                  }
                  if (bbqq[i].IsFixup!="1"){
                    bbqq[i].list[j].zt = false
                    bbqq[i].list[j].Qua=0
                  }
                }
                bbqq[i].sl = 0
              }
              this.kexuanlist=bbqq
              console.log(bbqq)
              console.log(this.Qlist)
          	})
          }
          this.pand=!this.pand
          return
        }
        if(is){
          name=this.pq[i].sz[j].GoodsID
          this.axios.get(this.$lujin+"/api/Default/UnitPrice?GoodsID="+name+"&ShopID="+this.ShopID)
          .then(res=>{
            console.log(res)
            console.log(res.data.data)
            var tab=res.data.data
            this.xq_list=res.data.data
            for(var i in tab){
              if(tab[i].MessyPrice==danjg){
                this.ggxb=i
              }
            }
          })
        }
        if(nb){
          name=this.pq[i].sz[j].GoodsID
          //console.log(name)
          if(this.IsNewGoodsRemark){
            this.axios.get(this.$lujin+"/api/Default/GetDisRemark?GoodsID="+name+"&ShopID="+this.ShopID).then(res=>{
              console.log(res)
              console.log(res.data.data)
              var sz=res.data.data
              /*for(var fw in fff){
                for(var p in sz){
                  for(var ok in sz[p].Data)
                  if(fff[fw]==sz[p].Data[ok].RemarkID){
                    sz[p].Data[ok].ZT=true;
                  }
                }
              }*/
              this.xq_la2=sz
              console.log(sz)
              document.getElementById("loader-wrapper").style.display="none"
            })
          }
          else{
            this.axios.get(this.$lujin+"/api/Default/GoodsRemark?name="+name+"&ShopID="+this.ShopID).then(res=>{
              console.log(res)
              var sz=res.data.data
              console.log(sz)
              for(var i in sz){
                sz[i].ZT=false;
              }
              for(var fw in fff){
                for(var p in sz){
                  if(fff[fw]==sz[p].RemarkID){
                    sz[p].ZT=true;
                  }
                }
              }
              this.xq_la=sz
              document.getElementById("loader-wrapper").style.display="none"
            })
          }
        }
        this.pand=!this.pand
      },
      jiaclick(){
        if(this.gmsl>=this.Numberpoints&&this.IsBuffet&&this.pq[this.xqxb_i].sz[this.xqxb_j].IsBuffetGoods){
          this.toast(this.ztlist[this.pickxb].ooo)
          return
        }
        this.gmsl+=1
      },
      jiaclick22(){
        var bbq=0
        var fwz=localStorage.getItem(this.ShopID+'list')
        var sql=[]
        console.log(fwz)
        if(fwz==null||fwz==""){
          sql=[]
        }else{
          sql=JSON.parse(fwz)
        }
        for(var ccc in sql){
          if(sql[ccc].IsBuffetGoods)
            bbq+=sql[ccc].sl
        }
        console.log(bbq,this.IsBuffet)
        if(bbq>=this.Numberpoints&&this.IsBuffet){
          this.toast(this.ztlist[this.pickxb].ooo)
          return
        }
        var zf="",js=0
        for(var i in this.xq_la2){
          for(var j in this.xq_la2[i].TRemarkGroupItemsTemp){
            if(this.xq_la2[i].TRemarkGroupItemsTemp[j].ZT){
              if(zf!="")zf+=",";
              zf+=this.xq_la2[i].TRemarkGroupItemsTemp[j].RemarkID
            }
          }
        }
        console.log(this.xq_list,this.ggxb)
        var GoodsID=this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID//编号
        var IsUnitPrice=this.pq[this.xqxb_i].sz[this.xqxb_j].IsUnitPrice//有没有做法
        var DisRemark=this.pq[this.xqxb_i].sz[this.xqxb_j].DisRemark//有没有单位
        var MessyPrice=this.xq_list[this.ggxb].MessyPrice//选中单位
        var Momey=this.pq[this.xqxb_i].sz[this.xqxb_j].MessyPrice
        var IsSetMeal=this.pq[this.xqxb_i].sz[this.xqxb_j].IsSetMeal
        console.log(sql,DisRemark,IsUnitPrice,MessyPrice,Momey,zf)
        for(var ss in sql){
          if(IsSetMeal)break;
          //没做法没单位
          if(GoodsID==sql[ss].id&&!IsUnitPrice&&!DisRemark){
            sql[ss].sl+=this.gmsl
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
          }
          //有做法没单位
          else if(sql[ss].zf==zf&&GoodsID==sql[ss].id&&!IsUnitPrice&&DisRemark){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
            //没做法有单位
          }else if(GoodsID==sql[ss].id&&IsUnitPrice&&!DisRemark&&MessyPrice+Momey==sql[ss].momey){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
          }else if(GoodsID==sql[ss].id&&IsUnitPrice&&DisRemark&&MessyPrice+Momey==sql[ss].momey&&sql[ss].zf==zf){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            return;
          }
        }//判断购物车是否有相同菜品相同做法
        this.jrclick(this.xqxb_i,this.xqxb_j,this.xq_list[this.ggxb].MessyPrice);//购物车没有
      },
      jiaclick2(){
        var bbq=0
        var fwz=localStorage.getItem(this.ShopID+'list')
        var sql=[]
        console.log(fwz)
        if(fwz==null||fwz==""){
          sql=[]
        }else{
          sql=JSON.parse(fwz)
        }
        for(var ccc in sql){
          if(sql[ccc].IsBuffetGoods)
            bbq+=sql[ccc].sl
        }
        console.log(bbq,this.IsBuffet)
        if(bbq>=this.Numberpoints&&this.IsBuffet){
          this.toast(this.ztlist[this.pickxb].ooo)
          return
        }
        //qweqwe
        var zf="",js=0
        for(var i in this.xq_la){
          if(this.xq_la[i].ZT){
            if(zf!="")zf+=",";js++;zf+=this.xq_la[i].RemarkID//obj.momey+=this.xq_la[i].AddPrice//做法附加价
          }
        }
        if(js<8){
          for(var p=js;p<8;p++){
            if(p==0){
              zf="0,0,0,0,0,0,0,0";break;
            }zf+=",0"
          }
        }//做法查询ID
        console.log(this.xq_list,this.ggxb)
        var GoodsID=this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID//编号
        var IsUnitPrice=this.pq[this.xqxb_i].sz[this.xqxb_j].IsUnitPrice//有没有做法
        var DisRemark=this.pq[this.xqxb_i].sz[this.xqxb_j].DisRemark//有没有单位
        var MessyPrice=this.xq_list[this.ggxb].MessyPrice//选中单位
        var Momey=this.pq[this.xqxb_i].sz[this.xqxb_j].MessyPrice
        var IsSetMeal=this.pq[this.xqxb_i].sz[this.xqxb_j].IsSetMeal
        console.log(sql,DisRemark,IsUnitPrice,MessyPrice,Momey,zf)
        for(var ss in sql){
          if(IsSetMeal)break;
          //没做法没单位
          if(GoodsID==sql[ss].id&&!IsUnitPrice&&!DisRemark){
            sql[ss].sl+=this.gmsl
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
          }
          //有做法没单位
          else if(sql[ss].zf==zf&&GoodsID==sql[ss].id&&!IsUnitPrice&&DisRemark){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
            //没做法有单位
          }else if(GoodsID==sql[ss].id&&IsUnitPrice&&!DisRemark&&MessyPrice+Momey==sql[ss].momey){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            this.xqesc()
            this.toast(this.zfpick[this.pickxb].tjcg)
            return;
          }else if(GoodsID==sql[ss].id&&IsUnitPrice&&DisRemark&&MessyPrice+Momey==sql[ss].momey&&sql[ss].zf==zf){
            sql[ss].sl+=1
            this.gmsl+=1
            localStorage.setItem(this.ShopID+'list',JSON.stringify(sql));
            var ppppp=0
            for(var i in sql){
              ppppp+=sql[i].sl
            }
            this.gwcsl=ppppp
            return;
          }
        }//判断购物车是否有相同菜品相同做法
        this.jrclick(this.xqxb_i,this.xqxb_j,this.xq_list[this.ggxb].MessyPrice);//购物车没有
      },
      jrclick(i,j,cm){
        //qweqwe
        if(this.gmsl==0){
          return
        }
        console.log(this.gmsl)
        var that=this
        var FromID=parseInt(Math.random()*100000)
        var obj={
          zt:true,
          xb_i:i,
          xb_j:j,
          FromID:FromID,
          IsChild:0,
          isRoot:this.pq[this.xqxb_i].sz[this.xqxb_j].IsSetMeal?1:0,
          sl:this.gmsl,
          bz:this.pq[i].sz[j].bz||"",
          id:this.pq[i].sz[j].GoodsID,
          momey:this.pq[i].sz[j].MessyPrice,
          addmomey:0,
          unit:this.IsBuffet?"":this.xq_list[this.ggxb].Unit,
          Goods:this.pq[i].sz[j].Goods,
          TwoGoods:this.pq[i].sz[j].TwoGoods,
          ThreeGoods:this.pq[i].sz[j].ThreeGoods,
          IsBuffetGoods:this.pq[i].sz[j].IsBuffetGoods,
          MinShare:this.pq[i].sz[j].MinShare,
          zf:"",
          zuofa1:"",
          zuofa2:"",
          zuofa3:"",
          getTime:(new Date()).getTime()
        }
        console.log(obj)
        if(this.pq[i].sz[j].IsBuffetGoods&&this.IsBuffet)
          obj.momey=this.pq[i].sz[j].Price
        console.log(this.xq_la)
        if(this.pq[i].sz[j].DisRemark){//有做法
          console.log("12213"+this.xq_la)
          if(!this.IsNewGoodsRemark){
            var bz="",js=0;
            for(var wf in this.xq_la){
              if(this.xq_la[wf].ZT){
                if(bz!="")bz+=",";
                js++;
                bz+=this.xq_la[wf].RemarkID
                obj.zuofa1+=this.xq_la[wf].Remark
                obj.zuofa2+=this.xq_la[wf].TwoWorkReMark
                obj.zuofa3+=this.xq_la[wf].ThreeWorkReMark
                obj.addmomey+=this.xq_la[wf].AddPrice
                //obj.momey+=this.xq_la[i].AddPrice//做法附加价
              }
            }
            console.log(js)
            if(this.pq[i].sz[j].IsMoreRemarkChoose==1&&js!=this.pq[i].sz[j].RemarkChooseNums){
              this.toast(this.picktan[this.pickxb].zfbx+this.pq[i].sz[j].RemarkChooseNums)
              return
            }
            if(this.pq[i].sz[j].IsMoreRemarkChoose==2&&js<this.pq[i].sz[j].RemarkChooseNums){
              this.toast(this.picktan[this.pickxb].zfzs)
              return
            }
            if(this.pq[i].sz[j].IsMoreRemarkChoose==3&&js>this.pq[i].sz[j].RemarkChooseNums){
              this.toast(this.picktan[this.pickxb].zfkx)
              return
            }
            if(js<8){
              for(var p=js;p<8;p++){
                if(p==0){
                  bz="0,0,0,0,0,0,0,0"
                  break
                }
                bz+=",0"
              }
            }
          }else{
            var bz="",js=0;
            for(var ii in this.xq_la2){
              var Choose=0
              for(var jj in this.xq_la2[ii].TRemarkGroupItemsTemp){
                if(this.xq_la2[ii].TRemarkGroupItemsTemp[jj].ZT){
                  Choose+=1
                  if(bz!="")bz+=",";
                  js++;
                  bz+=this.xq_la2[ii].TRemarkGroupItemsTemp[jj].RemarkID
                  obj.zuofa1+=this.xq_la2[ii].TRemarkGroupItemsTemp[jj].Remark
                  obj.zuofa2+=this.xq_la2[ii].TRemarkGroupItemsTemp[jj].TwoRemark
                  obj.zuofa3+=this.xq_la2[ii].TRemarkGroupItemsTemp[jj].ThreeRemark
                  obj.addmomey+=this.xq_la2[ii].TRemarkGroupItemsTemp[jj].AddPrice
                }
              }
              if(this.xq_la2[ii].GroupType==1&&Choose!=this.xq_la2[ii].MaxSelItems){
                this.toast(this.xq_la2[ii].GroupName+this.picktan[this.pickxb].zfbx+this.xq_la2[ii].MaxSelItems)
                return
              }
              if(this.xq_la2[ii].GroupType==2&&Choose<this.xq_la2[ii].MaxSelItems){
                this.toast(this.xq_la2[ii].GroupName+this.picktan[this.pickxb].zfzs+this.xq_la2[ii].MaxSelItems)
                return
              }
              if(this.xq_la2[ii].GroupType==3&&Choose>this.xq_la2[ii].MaxSelItems){
                this.toast(this.xq_la2[ii].GroupName+this.picktan[this.pickxb].zfkx+this.xq_la2[ii].MaxSelItems)
                return
              }
            }
            if(js<8){
              for(var p=js;p<8;p++){
                if(p==0){
                  bz="0,0,0,0,0,0,0,0"
                  break
                }
                bz+=",0"
              }
            }
            console.log(bz)
          }
          obj.zf=bz
        }else{
          obj.zf="0,0,0,0,0,0,0,0"
        }
        console.log(obj)
        var sz=[]
        console.log(cm,sz)
        if(cm){//有单位价格
          if(this.pq[i].sz[j].IsBuffetGoods&&this.IsBuffet){
            obj.momey=this.pq[i].sz[j].Price
          }else{
            obj.momey=cm
          }
          if(localStorage.getItem(this.ShopID+'list')){
            sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
            console.log(sz,cm)
            for(var k in sz){
              if(sz[k].xb_i==i && sz[k].xb_j==j && sz[k].momey==cm&&sz[k].id==this.pq[i].sz[j].GoodsID){
                sz[k].sl++;
                this.gmsl=sz[k].sl
                obj=false;
                break;
              }
            }
          }
        }else{
          console.log(obj.zf)
          var bpq=localStorage.getItem(this.ShopID+'list')
          console.log(bpq!='null',bpq)
          if(bpq!='null'){
            sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
            for(var k in sz){
              if(sz[k].xb_i==i && sz[k].xb_j==j && sz[k].zf==obj.zf && !obj.isRoot&&sz[k].id==this.pq[i].sz[j].GoodsID){
                console.log(1231)
                sz[k].sl++;
                this.gmsl=sz[k].sl
                obj=false;
                break;
              }
            }
          }
        }
        console.log(sz)
        if(obj){
          sz.push(obj)
          if(this.pq[i].sz[j].IsSetMeal){
            console.log(this.kexuanlist)
            for(var leng=0;leng<this.kexuanlist.length;leng++){
              if(this.kexuanlist[leng].IsFixup=="0"){
                var queleng=0
                for(var lengs=0;lengs<this.kexuanlist[leng].list.length;lengs++){
                  queleng+=parseInt(this.kexuanlist[leng].list[lengs].Qua)
                }
                console.log(queleng,this.kexuanlist[leng].MaxSelItems)
                if(queleng<this.kexuanlist[leng].MaxSelItems){
                  this.toast(this.kexuanlist[leng].SetMealGroup+this.foodlist[this.pickxb].on9)
                  return
                }
              }
            }
            for(var pp in this.Qlist){
              var duixiang={
                zt:true,
                xb_i:0,
                xb_j:0,
                FromID:FromID,
                IsChild:1,
                isRoot:0,
                sl:parseInt(this.Qlist[pp].Qua)*this.gmsl,
                jcQua:parseInt(this.Qlist[pp].Qua),
                bz:"",
                id:this.Qlist[pp].GoodsID,
                momey:this.Qlist[pp].Price?this.Qlist[pp].Price:0,
                unit:"",
                Goods:this.Qlist[pp].Goods,
                TwoGoods:this.Qlist[pp].TwoGoods,
                ThreeGoods:this.Qlist[pp].ThreeGoods,
                IsBuffetGoods:0,
                zf:"0,0,0,0,0,0,0,0",
                zuofa1:"",
                zuofa2:"",
                zuofa3:"",
                getTime:(new Date()).getTime()-(parseInt(Math.random()*1000))
              }
              sz.push(duixiang)
            }
          }
        }
		if(this.pq[i].sz[j].IsBuffetGoods&&this.buffsz.length>0){
			for(var ia in this.buffsz){
					for(var ja in this.buffsz[ia].Items){
						if(this.buffsz[ia].Items[ja].GoodsID==this.pq[i].sz[j].GoodsID){
							if(this.buffsz[ia].BuffetChooseType==1){
								if(this.gmsl>(this.buffsz[ia].MaxQua*this.MenuQua)){
									this.toast(this.picktan[this.pickxb].zfkx)
									return
								}
								if(this.buffsz[ia].Qua>=(this.buffsz[ia].MaxQua*this.MenuQua)){
									this.toast(this.picktan[this.pickxb].zfkx)
									return
								}
								if(this.buffsz[ia].Qua<(this.buffsz[ia].MaxQua*this.MenuQua)){
									this.buffsz[ia].Qua++
								}
							}
						}
					}
			}
		}
        localStorage.setItem(this.ShopID+'list', JSON.stringify(sz));
        this.gwclist=sz
        var bbq=0
        var sum=0
        for(var i in sz){
          sum+=sz[i].sl
          if(sz[i].IsBuffetGoods)
            bbq+=sz[i].sl
        }
        this.gwcsl=sum
        this.gwcsl2=bbq
        console.log(123123)
        this.toast(this.zfpick[this.pickxb].tjcg)
        this.xqesc()
      },
      imageLoad3(index){
        //this.$refs.xqdimg[index].children[0].children[1].style='display:none'
        this.$refs.xqdimg[index].children[0].children[1].src='../static/images/zwtp.png'
        //console.log(this.$refs.xqdimg[index].children[0].children[1])
      },
      imageLoad2(){
        this.$refs.xqimg.style='display:none'
        //this.$refs.xqimg.src='../static/images/zwtp.png'
        //console.log(this.$refs.xqimg)
      },
      imageLoad(e,m) {
        var img=this.$refs.piediv.children[e]?this.$refs.piediv.children[e].children[m+1].children[0].children[0]:'';
        //img.style="display:none"
        img.src='../static/images/zwtp.png'
      },
      imageLoad33(e,m) {
        var img=this.$refs.piediv.children[e]?this.$refs.piediv.children[e].children[m+1].children[0].children[0]:'';
        img.src='../static/images/zwtp.png'
      },
      /*判断分类样式状态*/
      handleScroll() {
        if(this.pand)
        return;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(this.$refs.piediv)
          var list=this.$refs.piediv.children
        else
          return;
        for(var i=0;i<list.length-1;i++){
          var yuyan=document.getElementById("yuyan").offsetHeight*2
          if(list[i].getBoundingClientRect().top-1<=yuyan && list[i+1].getBoundingClientRect().top>yuyan){
            this.feiclick(i,true);
          }
          if(i==list.length-2){
            if(list[i].getBoundingClientRect().top-1<=yuyan){
              this.feiclick(i,true);
            }
          }
        }
        //scrollTop 菜品栏顶部 》
      },
      ggclick(xb){
        console.log(xb)
        this.ggxb=xb
        var sql=JSON.parse(localStorage.getItem(this.ShopID+'list'))
        this.gmsl=1
        var zf="",js=0
        var GoodsID=this.pq[this.xqxb_i].sz[this.xqxb_j].GoodsID//编号
        var IsUnitPrice=this.pq[this.xqxb_i].sz[this.xqxb_j].IsUnitPrice//有没有单位
        var DisRemark=this.pq[this.xqxb_i].sz[this.xqxb_j].DisRemark//有没有做法
        var MessyPrice=this.xq_list[this.ggxb].MessyPrice//选中单位的价格
        var Momey=this.pq[this.xqxb_i].sz[this.xqxb_j].MessyPrice//菜品价格
        for(var p in this.xq_la){
          if(this.xq_la[p].ZT){
            if(zf!="")zf+=",";js++;zf+=this.xq_la[p].RemarkID//obj.momey+=this.xq_la[i].AddPrice//做法附加价
          }
        }
        if(js<4){
          for(var p=js;p<4;p++){
            if(p==0){
              zf="0,0,0,0";break;
            }zf+=",0"
          }
        }//做法查询ID
        for(var i in sql){
          if(GoodsID==sql[i].id&&MessyPrice+Momey==sql[i].momey&&!DisRemark&&IsUnitPrice){
            this.gmsl=sql[i].sl
          }else if(GoodsID==sql[i].id&&MessyPrice+Momey==sql[i].momey&&DisRemark&&IsUnitPrice&&zf==sql[i].zf){
            this.gmsl=sql[i].sl
          }
        }
      },
      /*用户点击确定*/
      confirm(res){
        console.log(res)
        this.pickxb=res[0].id-1
        this.pickindex=res[0].index-1
        if(res[0].index==1){
          this.WXLangGoodsxb=this.WXLangGoods.WXGoodsNameOne
        }
        if(res[0].index==2){
          this.WXLangGoodsxb=this.WXLangGoods.WXGoodsNameTwo
        }
        if(res[0].index==3){
          this.WXLangGoodsxb=this.WXLangGoods.WXGoodsNameThree
        }
        console.log(this.WXLangGoodsxb,this.WXLangGoods,res[0].id-1)
        this.result = res
        localStorage.setItem(getUrlParam('Shopid')+'pickxb',res[0].id-1);
        localStorage.setItem(getUrlParam('Shopid')+'WXLangGoodsxb',this.WXLangGoodsxb);
        localStorage.setItem(getUrlParam('Shopid')+'pickindex',res[0].index-1);
      },
      /*商品详情*/
      getNowTime: function() {
      	let dateTime
      	let yy = new Date().getFullYear()
      	let mm = new Date().getMonth() + 1
      	let dd = new Date().getDate()
      	let hh = new Date().getHours()
      	let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      	let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      	dateTime =yy+"-"+mm+"-"+dd+" "+ hh + ':' + mf + ':' + ss
      	return dateTime
      },
      datasj2:function(){
        var myDate = new Date();
        this.defaultlist2=[0]
        this.sjzt2=true
      },
    },
    mounted() {
      var that=this
      if(this.$route.query.Shopid==undefined){
        return
      }
      if(this.$route.query.Shopid=="24111808"&&!this.$route.query.AutoID){
        window.location.href = "/?id="+this.$route.query.id+"&Shopid="+this.$route.query.Shopid+"&AutoID="+(new Date()).getTime()
        return
      }
      if(this.$route.query.Shopid=="24111808"&&this.$route.query.AutoID){
        this.pickxb=7
        var sssjjj=(new Date()).getTime()
        if(sssjjj>(parseInt(this.$route.query.AutoID)+(180*60*1000))){
          this.sheetzt=true
          this.zfpicknr=this.zfpick[this.pickxb].qrsx
        }
        setInterval(()=>{
          var sj=(new Date()).getTime()
          if(sj>(parseInt(this.$route.query.AutoID)+(180*60*1000))){
            this.sheetzt=true
            this.zfpicknr=this.zfpick[this.pickxb].qrsx
          }
        },5000)
      }
      /*if(!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          window.location.href = "/pcindex?Shopid="+this.$route.query.Shopid+"&id="+this.$route.query.id
      }*/
      smoothscroll.polyfill();
      if(this.$route.query.PayState){
        this.PayState=this.$route.query.PayState
      }
      const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date();
      const Week = weekDays[today.getDay()];
      const WeekQua = today.getDay()==0?7:today.getDay()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      var time=hh+":"+mf+":"+ss
      this.axios.get(this.$lujin+'/api/Default/MenuType?ShopID='+this.$route.query.Shopid).then(res=>{
        console.log(res.data)
        that.Menulist=res.data
        this.axios.get(this.$lujin+'/api/Default/Goods?ShopID='+this.$route.query.Shopid+"&Week="+Week+"&Time="+time+"&WeekQua="+WeekQua).then(pts=>{
          console.log(this.$lujin+'/api/Default/Goods?ShopID='+this.$route.query.Shopid+"&Week="+Week+"&Time="+time+"&WeekQua="+WeekQua)
          console.log(pts)
          that.Goodslist=pts.data
          that.jiazai(true)
        })
      })
      if(this.$route.query.FoodState==1){
        this.foodzt=0
      }else if(this.$route.query.FoodState==2){
        this.foodzt=1
      }else{
        this.foodzt=0
      }
      if(this.$route.query.id!="Food"){
        console.log(123123123123123213213)
        this.axios.get(this.$lujin + "/api/Default/cha_zuo?ShopID=" + this.$route.query.Shopid + "&DeskID=" + this.$route.query.id)
          .then((res) => {
            that.Desk = res.data.data[0].Desk
        })
        this.axios.post(that.$lujin+"/api/default/TDeskzt?ShopID="+this.$route.query.Shopid+"&DeskID="+this.$route.query.id)
        .then((res)=>{
          console.log(res)
          console.log(res.data[0].TableTime)
          console.log(parseInt(Date.now()/1000))
          if(res.data[0].TableTime<parseInt(Date.now()/1000)){
            that.DeskMin=0
            that.IsBuffet=0
          }else{
            that.DeskMin=parseInt((res.data[0].TableTime-parseInt(Date.now()/1000))/60)
          }
        })
        setInterval(()=>{
          this.axios.post(that.$lujin+"/api/default/TDeskzt?ShopID="+this.$route.query.Shopid+"&DeskID="+this.$route.query.id)
          .then((res)=>{
            that.$nextTick(()=>{
              if(res.data[0].TableTime<parseInt(Date.now()/1000)){
                that.DeskMin=0
                that.IsBuffet=0
              }else{
                that.DeskMin=parseInt((res.data[0].TableTime-parseInt(Date.now()/1000))/60)
              }
              that.$forceUpdate()
            })
          })
          this.axios.post(that.$lujin+"/api/default/TDeskzt?ShopID="+this.$route.query.Shopid+"&DeskID="+this.$route.query.id)
          .then((res)=>{
            console.log(res.data)
            if(this.$route.query.SheetID==undefined){
              //console.log("普通")
            }
            if(this.$route.query.SheetID==res.data[0].SheetID){
              //console.log("有效期")
            }
            if(this.$route.query.SheetID!=undefined&&this.$route.query.SheetID!=res.data[0].SheetID){
              this.sheetzt=true
              //console.log("失效")
            }
          })
        },20000)
      }else{
        document.getElementById("loader-wrapper").style.display="none"
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      }
    },
  }
</script>

<style>
  textarea{font-size:.32rem !important;}
  input{font-size:.32rem !important;}
  .food_xxs span{margin:0 .1rem 0 0;}
  .food_xxs>div{width:90%;margin:0 auto;line-height:.8rem;display:flex;margin-top:.3rem;}
  .food_xxs>div input{font-size:.36rem; width: 90%;height:.8rem;border-radius:5px;outline:none;border:none;border:1px solid #000;box-sizing:border-box;-moz-box-sizing:border-box; /* Firefox */-webkit-box-sizing:border-box;}
  .food_xxs>div span{font-size:.28rem;line-height:.8rem;}
  .food_xxs .time{border-radius:5px;border:1px solid #000;height:.8rem;display:flex;justify-content:space-between;margin-top:.3rem;}
  .food_xxs .time .foodspan{margin-right:.2rem;}
  .food_table{
    display: flex;
    font-size:.26rem;
    justify-content:space-around;
  }
  .food_table div{width:42%; border:1px solid #000;line-height:.6rem;border-radius:.6rem;}
  .food_table div.on{color:#FFB000;border:1px solid #FFB000;}
.chromeframe {
        margin: 0.2em 0;
        background: #ccc;
        color: #000;
        padding: 0.2em 0;
      }
      #loader-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999;
      }
      #loader {
        display: block;
        position: relative;
        left: 50%;
        top: 50%;
        width: 150px;
        height: 150px;
        margin: -75px 0 0 -75px;
        border-radius: 50%;
        border: 3px solid transparent;
        /* COLOR 1 */
        border-top-color: orange;
        -webkit-animation: spin 2s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -ms-animation: spin 2s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -moz-animation: spin 2s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -o-animation: spin 2s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 2s linear infinite;
        /* Chrome, Firefox 16+, IE 10+, Opera */
        z-index: 1001;
      }
      #loader:before {
        content: "";
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 3px solid transparent;
        /* COLOR 2 */
        border-top-color: orange;
        -webkit-animation: spin 3s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -moz-animation: spin 3s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -o-animation: spin 3s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -ms-animation: spin 3s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 3s linear infinite;
        /* Chrome, Firefox 16+, IE 10+, Opera */
      }
      #loader:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: orange;
        /* COLOR 3 */
        -moz-animation: spin 1.5s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -o-animation: spin 1.5s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -ms-animation: spin 1.5s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        -webkit-animation: spin 1.5s linear infinite;
        /* Chrome, Opera 15+, Safari 5+ */
        animation: spin 1.5s linear infinite;
        /* Chrome, Firefox 16+, IE 10+, Opera */
      }
      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          /* Chrome, Opera 15+, Safari 3.1+ */
          -ms-transform: rotate(0deg);
          /* IE 9 */
          transform: rotate(0deg);
          /* Firefox 16+, IE 10+, Opera */
        }
        100% {
          -webkit-transform: rotate(360deg);
          /* Chrome, Opera 15+, Safari 3.1+ */
          -ms-transform: rotate(360deg);
          /* IE 9 */
          transform: rotate(360deg);
          /* Firefox 16+, IE 10+, Opera */
        }
      }
      @keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          /* Chrome, Opera 15+, Safari 3.1+ */
          -ms-transform: rotate(0deg);
          /* IE 9 */
          transform: rotate(0deg);
          /* Firefox 16+, IE 10+, Opera */
        }
        100% {
          -webkit-transform: rotate(360deg);
          /* Chrome, Opera 15+, Safari 3.1+ */
          -ms-transform: rotate(360deg);
          /* IE 9 */
          transform: rotate(360deg);
          /* Firefox 16+, IE 10+, Opera */
        }
      }
      #loader-wrapper .loader-section {
        position: fixed;
        top: 0;
        width: 51%;
        height: 100%;
        background: #FFF;
        /* Old browsers */
        z-index: 1000;
        -webkit-transform: translateX(0);
        /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: translateX(0);
        /* IE 9 */
        transform: translateX(0);
        /* Firefox 16+, IE 10+, Opera */
      }
      #loader-wrapper .loader-section.section-left {
        left: 0;
      }
      #loader-wrapper .loader-section.section-right {
        right: 0;
      }
      /* Loaded */
      .loaded #loader-wrapper .loader-section.section-left {
        -webkit-transform: translateX(-100%);
        /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: translateX(-100%);
        /* IE 9 */
        transform: translateX(-100%);
        /* Firefox 16+, IE 10+, Opera */
        -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      }
      .loaded #loader-wrapper .loader-section.section-right {
        -webkit-transform: translateX(100%);
        /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: translateX(100%);
        /* IE 9 */
        transform: translateX(100%);
        /* Firefox 16+, IE 10+, Opera */
        -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      }
      .loaded #loader {
        opacity: 0;
        -webkit-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
      }
      .loaded #loader-wrapper {
        visibility: hidden;
        -webkit-transform: translateY(-100%);
        /* Chrome, Opera 15+, Safari 3.1+ */
        -ms-transform: translateY(-100%);
        /* IE 9 */
        transform: translateY(-100%);
        /* Firefox 16+, IE 10+, Opera */
        -webkit-transition: all 0.3s 1s ease-out;
        transition: all 0.3s 1s ease-out;
      }
      /* JavaScript Turned Off */
      .no-js #loader-wrapper {
        display: none;
      }
      .no-js h1 {
        color: #222222;
      }
      #loader-wrapper .load_title {
        font-family: 'Open Sans';
        color: orange;
        font-size: 19px;
        width: 100%;
        text-align: center;
        z-index: 9999999999999;
        position: absolute;
        top: 70%;
        opacity: 1;
        line-height: 30px;
      }
      #loader-wrapper .load_title span {
        font-weight: normal;
        font-style: italic;
        font-size: 13px;
        color: #FFF;
        opacity: 0.5;
      }
  /* 确认弹框 start */
  .confirmLayercovering {
    position: fixed;
    width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1005;
      background-color: rgba(0, 0, 0, .5);
      display: none;
      font-size: 0;
    }
    #confirminput{
      height: 1.5rem;
      outline: none;
      width: 98%;
    }
    .confirmLayer {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 6rem;
      height: 3.5rem;
      background: #fff;
      border-radius: 10px;
      padding: .1rem;
      box-sizing: border-box;
    }

    .confirmTit {
      width: 100%;
      color: #333;
      font-size: .4rem;
      margin-top:.5rem;
    }

    .confirmbtns {
      position: absolute;
      bottom: .2rem;
      width: 95%;
      height: 25%;
      display: flex;
    }

    .confirmbtns a {
      font-size: .36rem;
      display: inline-block;
      flex: 1;
      height: 100%;
      line-height: 2.5;
      border-radius: 4px;
    }

    .confirmClose {
      background-color: #bbb;
      color: #fff;
      margin-right: .1rem;
    }

    .confirmSure {
      background: #ff7035;
      color: #fff;
    }
    .xq_img{
      padding-top: .92rem;
    }
    /* 确认弹框 end */
  .toast {
  			position: fixed;
  			z-index: 2000;
  			left: 50%;
  			top: 45%;
  			transition: all 5s;
  			-webkit-transform: translateX(-50%) translateY(-50%);
  			-moz-transform: translateX(-50%) translateY(-50%);
  			-ms-transform: translateX(-50%) translateY(-50%);
  			-o-transform: translateX(-50%) translateY(-50%);
  			transform: translateX(-50%) translateY(-50%);
  			text-align: center;
  			border-radius: 5px;
  			color: #FFF;
  			background: rgba(17, 17, 17, 0.7);
  			height:1rem;
  			padding: 0 15px;
        font-size: .3rem;
        display:flex;
        align-items: center;
        justify-content:space-around;
    }
  * {
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #f7f7f7;
  }
  .goods-img{
    position: absolute;
    width: 120px;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .goods-img img{
    width: 100%;
  }
  .goods-title{
    position: absolute;
    width: 240px;
    top: 10px;
    left: 130px;
    font-size: 14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goods-price{
    position: absolute;
    bottom: 20px;
    left: 130px;
  }
  .goods-card{
    background-color: #eee;
    width: 100%;
    height: 120px;
    position: relative;
    margin-bottom: 5px;
  }
  .goods-card .iconfont{
    color:#3BA9F6;
    font-size: 30px;
    position: absolute;
  }
  .add{
    right: 20px;
    bottom: 20px;
  }
  .goods-num{
    position: absolute;
    bottom: 25px;
    right: 55px;
  }
  .demo-ul{
      text-align: right ;
  }
  .demo-ul li{
    margin:10px 0px;
    box-sizing:border-box;
    padding-right: 20px;

  }
  .addBtn{
      position: absolute;
      top: 50px;
      right: 50px;
      width: 20px;
      height: 20px;
      background: blue;
      border-radius: 50%;
  }
  .cart{
      position: absolute;
      left: 30px;
      bottom: 30px;
      width: 100px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      /* border: 1px solid #ccc; */
  }
  .ball{
        position: fixed;
        z-index: 100;
        left: 70px;
        bottom: 45px;
  }
  .drop-enter-active{
          transition: all 0.5s cubic-bezier(0.49, -0.29, 0.75, 0.41);
  }
  .inner{
          width: 20px;
          height: 20px;
          border-radius: 50%;
          /* background: red; */
          transition: all 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/pccomponents/index.vue